/*
 * LP RESKIN 2026 — Interactions
 * ------------------------------------------------------------
 * 1. Inclinaison des cartes qui suit le curseur (facon Apple TV)
 * 2. Rail de controle du carrousel : fleche, points, fleche
 *    regroupes au centre sous les cartes
 *
 * Le JS ne pose que des variables CSS. Toute l'apparence reste
 * dans lp-reskin.css, donc rien ne casse si ce fichier ne se
 * charge pas.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = window.matchMedia('(pointer: coarse)').matches;

  /* ----------------------------------------------------------
     1. INCLINAISON AU CURSEUR
     ---------------------------------------------------------- */
  var TILT_SELECTOR = '.article-card, .product-card, .lp-ranges__tile, .lp-ranges__panel, .lp-promos__banner';
  var MAX_TILT = 7; // degres

  function bindTilt(card) {
    if (card.dataset.lpTilt === 'on') return;
    card.dataset.lpTilt = 'on';

    var frame = null;

    function onMove(e) {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        var r = card.getBoundingClientRect();
        if (!r.width || !r.height) return;

        var px = (e.clientX - r.left) / r.width;   // 0 -> 1
        var py = (e.clientY - r.top) / r.height;   // 0 -> 1

        // Centre = 0. Le signe est inverse sur X pour que la carte
        // bascule vers le curseur et non a l'oppose.
        var ry = (px - 0.5) * 2 * MAX_TILT;
        var rx = (0.5 - py) * 2 * MAX_TILT;

        card.style.setProperty('--lp-ry', ry.toFixed(2) + 'deg');
        card.style.setProperty('--lp-rx', rx.toFixed(2) + 'deg');
        card.style.setProperty('--lp-mx', (px * 100).toFixed(1) + '%');
        card.style.setProperty('--lp-my', (py * 100).toFixed(1) + '%');
      });
    }

    function onLeave() {
      if (frame) {
        cancelAnimationFrame(frame);
        frame = null;
      }
      card.style.setProperty('--lp-ry', '0deg');
      card.style.setProperty('--lp-rx', '0deg');
      card.style.setProperty('--lp-mx', '50%');
      card.style.setProperty('--lp-my', '50%');
    }

    card.addEventListener('pointermove', onMove);
    card.addEventListener('pointerleave', onLeave);
  }

  function scanTilt(root) {
    if (reduced || coarse) return;
    (root || document).querySelectorAll(TILT_SELECTOR).forEach(bindTilt);
  }

  /* ----------------------------------------------------------
     2. RAIL DE CONTROLE DU CARROUSEL
     Les fleches sont positionnees sur les bords du conteneur,
     qui deborde de l'ecran : elles finissent hors champ. On les
     regroupe avec les points, au centre, sous les cartes.
     ---------------------------------------------------------- */
  function makeArrow(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lp-rail__arrow lp-rail__arrow--' + dir;
    b.setAttribute('aria-label', dir === 'prev' ? 'Previous' : 'Next');
    b.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="' + (dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '" ' +
      'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return b;
  }

  /* Recupere l'instance Swiper du conteneur. Swiper Element la
     publie sur la propriete .swiper une fois initialisee. */
  function getSwiper(container) {
    return container.swiper || null;
  }

  function wire(button, container, dir) {
    button.addEventListener('click', function () {
      var sw = getSwiper(container);
      if (sw) {
        if (dir === 'prev') sw.slidePrev();
        else sw.slideNext();
        return;
      }
      // Repli : on clique le bouton d'origine du theme s'il existe.
      var native = container.querySelector('.swiper-button-' + dir);
      if (native) native.click();
    });
  }

  function syncDisabled(container, prevBtn, nextBtn) {
    function update() {
      var sw = getSwiper(container);
      if (!sw) return;
      prevBtn.disabled = !!sw.isBeginning;
      nextBtn.disabled = !!sw.isEnd;
    }

    update();
    var sw = getSwiper(container);
    if (sw && sw.on) {
      sw.on('slideChange', update);
      sw.on('reachBeginning', update);
      sw.on('reachEnd', update);
      sw.on('fromEdge', update);
    } else {
      // L'instance n'existe pas encore : on retente brievement.
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        var s = getSwiper(container);
        if (s || tries > 20) {
          clearInterval(t);
          if (s) {
            update();
            s.on('slideChange', update);
          }
        }
      }, 250);
    }
  }

  function buildRail(container) {
    if (container.dataset.lpRail === 'on') return;

    // Points de pagination, ou a defaut la barre de defilement
    // (recommandations produit) : l'un ou l'autre fait le rail.
    var dots = container.querySelector('.swiper-pagination') ||
               container.querySelector('.swiper-scrollbar');
    if (!dots) return;

    container.dataset.lpRail = 'on';

    // Les fleches d'origine du theme restent dans le DOM mais ne
    // sont pas fiables : on cree les notres et on masque les leurs.
    var oldPrev = container.querySelector('.swiper-button-prev');
    var oldNext = container.querySelector('.swiper-button-next');
    if (oldPrev) oldPrev.classList.add('lp-hidden');
    if (oldNext) oldNext.classList.add('lp-hidden');

    var prevBtn = makeArrow('prev');
    var nextBtn = makeArrow('next');
    prevBtn.classList.add('lp-rail__arrow--edge');
    nextBtn.classList.add('lp-rail__arrow--edge');

    // Les fleches se posent sur le conteneur d'articles, pas sur
    // le swiper : ce dernier deborde volontairement a droite pour
    // laisser voir la carte suivante, donc son bord droit est
    // hors ecran. Le conteneur, lui, reste dans la largeur de la
    // page.
    var host = container.closest('.featured-blog__article-container') ||
               container.closest('.featured-collection__product-container') ||
               container.closest('.product-recommendations__slider-wrapper') ||
               container.parentElement;
    if (host) {
      host.classList.add('lp-arrow-host');
      host.appendChild(prevBtn);
      host.appendChild(nextBtn);
    }

    var rail = document.createElement('div');
    rail.className = 'lp-rail';
    rail.appendChild(dots);

    container.appendChild(rail);

    wire(prevBtn, container, 'prev');
    wire(nextBtn, container, 'next');
    syncDisabled(container, prevBtn, nextBtn);

    // Le bouton de bas de section est rendu avant le rail par le
    // Liquid. On le repasse en dernier pour qu'il se retrouve
    // sous les points.
    var cta = container.querySelector('.featured-blog__link-wrapper, .featured-collection__link-wrapper');
    if (cta) container.appendChild(cta);
  }

  function scanRails(root) {
    (root || document)
      .querySelectorAll('[class*="articles-swiper-container"], [class*="products-swiper-container"], [data-product-image-swiper]')
      .forEach(buildRail);
  }

  /* ----------------------------------------------------------
     3. HEADER PAR-DESSUS LE HERO
     On mesure la hauteur reelle du header et on la publie en
     variable CSS. Le hero remonte d'autant : le header reste
     collant au defilement, mais flotte au-dessus de l'image.
     ---------------------------------------------------------- */
  function measureHeader() {
    // Somme des hauteurs de MISE EN PAGE des sections du groupe
    // d'en-tete (annonce + header). offsetHeight est independant
    // du defilement — contrairement a getBoundingClientRect dont
    // le bas reste fige quand le header est collant, ce qui
    // faisait exploser la marge a chaque recalcul en cours de
    // defilement et aspirait toute la page vers le haut.
    var sections = document.querySelectorAll('.shopify-section-group-header-group');
    var total = 0;
    var pillBottom = 0;
    sections.forEach(function (s) {
      // Bas de la pilule (.header) par rapport au haut de page :
      // sections precedentes + distance entre le haut de sa
      // section et son bas. Les deux rects sont pris au meme
      // instant, donc la difference ne depend pas du defilement
      // (le header colle et la pilule bouge avec lui). Sert au
      // hero pour aligner la bande haute exactement sous le menu.
      var pill = s.querySelector('.header');
      if (pill && !pillBottom) {
        pillBottom = total + (pill.getBoundingClientRect().bottom - s.getBoundingClientRect().top);
      }
      total += s.offsetHeight;
    });

    if (total > 0) {
      document.documentElement.style.setProperty('--lp-header-h', total + 'px');
      if (pillBottom > 0) {
        document.documentElement.style.setProperty('--lp-header-pill-b', Math.round(pillBottom) + 'px');
      }

      var heroSection = document.querySelector('.lp-hero-section');
      if (heroSection) {
        heroSection.style.marginTop = '-' + total + 'px';
      }
    }
  }

  /* ----------------------------------------------------------
     4. HERO QUI SUIT LE CURSEUR
     Deux couches : l'image pivote legerement vers le curseur
     (rotateX/Y, meme convention que les cartes) et glisse de
     quelques pixels ; le texte glisse en sens inverse. C'est
     l'ecart entre les deux qui donne la profondeur.
     ---------------------------------------------------------- */
  var HERO_TILT = 2.4; // degres, bien moins que les cartes : l'image est plein ecran

  function bindHero() {
    if (reduced || coarse) return;

    var hero = document.querySelector('.lp-hero');
    if (!hero || hero.dataset.lpHero === 'on') return;
    hero.dataset.lpHero = 'on';

    var media = hero.querySelector('.lp-hero__media');
    if (!media) return;

    var frame = null;

    hero.addEventListener('pointermove', function (e) {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        var r = hero.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;   // -0.5 -> 0.5
        var py = (e.clientY - r.top) / r.height - 0.5;

        hero.style.setProperty('--lp-hx', (px * -18).toFixed(1) + 'px');
        hero.style.setProperty('--lp-hy', (py * -12).toFixed(1) + 'px');
        hero.style.setProperty('--lp-hry', (px * 2 * HERO_TILT).toFixed(2) + 'deg');
        hero.style.setProperty('--lp-hrx', (py * -2 * HERO_TILT).toFixed(2) + 'deg');
        hero.style.setProperty('--lp-hmx', ((px + 0.5) * 100).toFixed(1) + '%');
        hero.style.setProperty('--lp-hmy', ((py + 0.5) * 100).toFixed(1) + '%');
      });
    });

    hero.addEventListener('pointerleave', function () {
      hero.style.setProperty('--lp-hx', '0px');
      hero.style.setProperty('--lp-hy', '0px');
      hero.style.setProperty('--lp-hry', '0deg');
      hero.style.setProperty('--lp-hrx', '0deg');
      hero.style.setProperty('--lp-hmx', '50%');
      hero.style.setProperty('--lp-hmy', '50%');
    });
  }

  /* ----------------------------------------------------------
     5. TEMOIGNAGES EN PILE (section lp-testimonials)
     Logique ici plutot qu'en script inline : le hot-reload de
     theme dev remplace le HTML de la section sans executer ses
     scripts. Le MutationObserver du bas rebranche tout seul.
     ---------------------------------------------------------- */
  function initTdeck(root) {
    if (root.dataset.lpTdeckReady === 'on') return;
    root.dataset.lpTdeckReady = 'on';

    var deck = root.querySelector('[data-lp-tdeck-deck]');
    var cards = deck ? Array.prototype.slice.call(deck.querySelectorAll('[data-lp-tdeck-card]')) : [];
    var n = cards.length;
    if (!deck || n === 0) return;

    var prevBtn = root.querySelector('[data-lp-tdeck-prev]');
    var nextBtn = root.querySelector('[data-lp-tdeck-next]');
    var counter = root.querySelector('[data-lp-tdeck-current]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-lp-tdeck-dots] li'));
    var progress = root.querySelector('[data-lp-tdeck-progress]');
    var interval = parseInt(root.getAttribute('data-lp-tdeck-interval'), 10) * 1000 || 7000;
    var current = 0;
    var busy = false;
    var timer = null;
    var paused = false;

    function layout() {
      cards.forEach(function (card, idx) {
        var depth = (idx - current + n) % n;
        card.style.setProperty('--i', depth);
        card.setAttribute('aria-hidden', depth === 0 ? 'false' : 'true');
        if (depth === 0) { card.setAttribute('aria-current', 'true'); } else { card.removeAttribute('aria-current'); }
      });
      deck.style.height = cards[current].offsetHeight + 'px';
      if (counter) counter.textContent = ('0' + (current + 1)).slice(-2);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    }

    function tick() {
      if (!progress) return;
      progress.style.transition = 'none';
      progress.style.transform = 'scaleX(0)';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          progress.style.transition = 'transform ' + interval + 'ms linear';
          progress.style.transform = 'scaleX(1)';
        });
      });
    }

    function restart() {
      clearInterval(timer);
      if (reduced || paused || n < 2) return;
      tick();
      timer = setInterval(function () { go(1); }, interval);
    }

    function go(dir) {
      if (busy || n < 2) return;
      busy = true;
      var top = cards[current];

      if (dir > 0 && !reduced) {
        top.classList.add('is-leaving');
        setTimeout(function () {
          top.classList.add('is-resetting');
          current = (current + 1) % n;
          layout();
          top.classList.remove('is-leaving');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              top.classList.remove('is-resetting');
              busy = false;
            });
          });
        }, 360);
      } else {
        current = (current + dir + n) % n;
        layout();
        setTimeout(function () { busy = false; }, reduced ? 0 : 500);
      }
      restart();
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });
    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    deck.addEventListener('click', function (e) {
      if (e.target.closest('a, button')) return;
      go(1);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') go(1);
      if (e.key === 'ArrowLeft') go(-1);
    });

    root.addEventListener('mouseenter', function () { paused = true; clearInterval(timer); if (progress) progress.style.transition = 'none'; });
    root.addEventListener('mouseleave', function () { paused = false; restart(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { restart(); } else { clearInterval(timer); }
        });
      }, { threshold: 0.3 }).observe(root);
    } else {
      restart();
    }

    layout();
    window.addEventListener('resize', function () { deck.style.height = cards[current].offsetHeight + 'px'; });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { deck.style.height = cards[current].offsetHeight + 'px'; });
    }
  }

  function scanTdeck(root) {
    (root || document).querySelectorAll('[data-lp-tdeck]').forEach(initTdeck);
  }

  /* ----------------------------------------------------------
     6. FENETRE DE LA PROMO (section lp-announcement)
     Delegation sur le document : survit au hot-reload de
     theme dev et aux sections chargees en differe. <dialog>
     natif : Echap ferme deja, on ajoute le clic sur le fond.
     ---------------------------------------------------------- */
  function openPromo(id) {
    var dlg = document.getElementById(id);
    if (!dlg || typeof dlg.showModal !== 'function') return;
    if (!dlg.open) dlg.showModal();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-lp-announce-open]');
    if (opener) {
      e.preventDefault();
      openPromo(opener.getAttribute('data-lp-announce-open'));
      return;
    }

    var closer = e.target.closest('[data-lp-announce-close]');
    if (closer) {
      var d = closer.closest('dialog');
      if (d) d.close();
      return;
    }

    // Clic sur le fond : la cible est le <dialog> lui-meme,
    // pas son contenu (qui est dans .lp-announce__modal-inner).
    if (e.target.matches && e.target.matches('dialog.lp-announce__modal')) {
      e.target.close();
    }
  });

  /* ----------------------------------------------------------
     7. FICHE PRODUIT : DESCRIPTION EN PANNEAUX
     La description Shopify est un seul bloc HTML de deux ecrans.
     On la decoupe a chaque titre (h2, ou h2 + h3 selon le
     reglage du bloc) en <details> natifs : un panneau par
     section, titre du panneau = texte du titre. Ce qui precede
     le premier titre garde le titre du bloc (« Description »).
     Les morceaux vides (un h2 suivi directement d'un h3) sont
     ignores. Sans JS, la description reste dans un seul panneau.
     ---------------------------------------------------------- */
  function splitDescription(root) {
    if (root.dataset.lpSplitReady === 'on') return;
    root.dataset.lpSplitReady = 'on';

    var mode = root.getAttribute('data-lp-split') || 'h2';
    if (mode === 'none') return;
    var levels = mode.toUpperCase().split(',');

    var first = root.querySelector('[data-lp-desc-details]');
    var source = root.querySelector('[data-lp-desc-source]');
    if (!first || !source) return;

    var chunks = [];
    var current = { title: first.getAttribute('data-lp-title') || 'Description', nodes: [] };

    Array.prototype.slice.call(source.childNodes).forEach(function (node) {
      if (node.nodeType === 1 && levels.indexOf(node.tagName) !== -1) {
        chunks.push(current);
        current = { title: (node.textContent || '').trim(), nodes: [] };
      } else {
        current.nodes.push(node);
      }
    });
    chunks.push(current);

    chunks = chunks.filter(function (c) {
      return c.title && c.nodes.some(function (n) {
        return n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim());
      });
    });
    if (chunks.length < 2) return;

    var frag = document.createDocumentFragment();
    chunks.forEach(function (c, i) {
      var d = document.createElement('details');
      d.className = 'lp-acc';
      if (i === 0 && first.open) d.open = true;

      var s = document.createElement('summary');
      s.className = 'lp-acc__title';
      var label = document.createElement('span');
      label.textContent = c.title;
      s.appendChild(label);

      var body = document.createElement('div');
      body.className = 'lp-acc__body rte';
      c.nodes.forEach(function (n) { body.appendChild(n); });

      d.appendChild(s);
      d.appendChild(body);
      frag.appendChild(d);
    });

    first.replaceWith(frag);
  }

  function scanDescriptions(root) {
    (root || document).querySelectorAll('[data-lp-desc]').forEach(splitDescription);
  }

  /* ----------------------------------------------------------
     8. FICHE PRODUIT : BARRE D'ACHAT + CHANGEMENT DE SAVEUR
     - La barre collante apparait quand le bouton d'achat
       principal sort de l'ecran vers le haut (ordinateur).
       Elle clique le vrai bouton du formulaire.
     - A chaque changement d'option, on relit la variante
       courante (select cache du formulaire, sinon l'URL), on
       met la barre a jour, on fait respirer la galerie et on
       teinte la lueur derriere le sac avec la couleur de la
       pastille de saveur choisie.
     ---------------------------------------------------------- */
  function bindProductPage() {
    var wrap = document.querySelector('[data-product-wrapper]');
    if (!wrap || wrap.dataset.lpPdp === 'on') return;
    wrap.dataset.lpPdp = 'on';

    var bar = wrap.querySelector('[data-lp-buybar]');
    var submit = wrap.querySelector('.product-main__submit-wrapper .product-form__submit');
    var gallery = wrap.querySelector('.product-main__image-container');
    var variants = [];

    try {
      var json = wrap.querySelector('[data-lp-variants]');
      if (json) variants = JSON.parse(json.textContent);
    } catch (e) { variants = []; }

    // --- barre collante --------------------------------------
    if (bar && submit && 'IntersectionObserver' in window) {
      var desktop = window.matchMedia('(min-width: 62em)');
      var passed = false;

      var syncBar = function () {
        var on = passed && desktop.matches;
        bar.classList.toggle('is-visible', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      };

      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        // Visible => on cache. Sorti par le haut => on montre.
        passed = !en.isIntersecting && en.boundingClientRect.top < 0;
        syncBar();
      }, { threshold: 0 });
      io.observe(submit);

      desktop.addEventListener('change', syncBar);

      var cta = bar.querySelector('[data-lp-buybar-cta]');
      if (cta) {
        cta.addEventListener('click', function () {
          if (submit.disabled) return;
          submit.click();
          cta.classList.add('is-busy');
          setTimeout(function () { cta.classList.remove('is-busy'); }, 1200);
        });
      }
    }

    // --- variante courante -----------------------------------
    function currentVariantId() {
      var sel = wrap.querySelector('select[name="id"]');
      if (sel && sel.value) return String(sel.value);
      var m = window.location.search.match(/[?&]variant=(\d+)/);
      return m ? m[1] : null;
    }

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function swatchColor() {
      var checked = wrap.querySelector('.swatches__swatch.is-visual input:checked');
      if (!checked) return null;
      var dot = checked.parentElement.querySelector('.lp-swatch__dot');
      return dot ? dot.style.getPropertyValue('--lp-chip').trim() : null;
    }

    function applyVariant() {
      var v = findVariant(currentVariantId());
      var color = swatchColor();

      if (bar && v) {
        var img = bar.querySelector('[data-lp-buybar-img]');
        var vt = bar.querySelector('[data-lp-buybar-variant]');
        var pr = bar.querySelector('[data-lp-buybar-price]');
        var cta = bar.querySelector('[data-lp-buybar-cta]');
        if (img) {
          // Image de la variante, sinon celle du produit : la
          // plupart des saveurs n'ont pas d'image propre. On ne
          // masque la balise que si aucune des deux n'existe.
          var src = v.image || bar.getAttribute('data-lp-buybar-fallback') || '';
          if (src) {
            img.src = src;
            img.hidden = false;
          } else {
            img.removeAttribute('src');
            img.hidden = true;
          }
        }
        if (vt) vt.textContent = v.title === 'Default Title' ? '' : v.title;
        if (pr) pr.textContent = v.price;
        if (cta) cta.disabled = !v.available;
      }

      if (color) {
        wrap.style.setProperty('--lp-swatch-glow', color);
        if (bar) bar.style.setProperty('--lp-swatch-glow', color);
      }

      if (gallery) {
        gallery.classList.remove('is-swapping');
        // Reflow pour relancer l'animation a chaque changement.
        void gallery.offsetWidth;
        gallery.classList.add('is-swapping');
        setTimeout(function () { gallery.classList.remove('is-swapping'); }, 700);
      }

      applyStock(v);
      applyTaste(v);
      applyStackTotal(v);
      applyFacts(v);
      applyGallery(v);
    }

    // --- galerie recto / verso -------------------------------
    // Le Liquid marque chaque slide data-lp-side="front|back" et
    // data-lp-flavour. On ne laisse dans le swiper que la paire de
    // la saveur courante ; les autres slides sont gardees en memoire
    // et remises a chaque changement. Le theme, lui, ne voit qu'un
    // swiper de deux images : sa propre logique (slideTo sur
    // l'image de variante) continue de tomber sur l'index 0.
    var swiperEl = wrap.querySelector('[data-product-image-swiper]');
    var sidesUi = wrap.querySelector('[data-lp-sides]');
    var allSlides = swiperEl ? Array.prototype.slice.call(swiperEl.querySelectorAll('.swiper-slide')) : [];
    var hasSides = allSlides.some(function (s) { return s.getAttribute('data-lp-side') === 'back'; });
    var currentSet = [];

    function slidesFor(v) {
      if (!v) return [];
      var own = allSlides.filter(function (s) { return s.getAttribute('data-lp-flavour') === v.title; });
      if (own.length) return own;
      // Saveur sans visuel propre : les images non marquees.
      return allSlides.filter(function (s) { return !s.getAttribute('data-lp-flavour'); });
    }

    function setSideBtn(idx) {
      if (!sidesUi) return;
      sidesUi.querySelectorAll('[data-lp-side-btn]').forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.getAttribute('data-lp-side-btn'), 10) === idx);
      });
    }

    function applyGallery(v) {
      if (!hasSides || !swiperEl) return;
      var set = slidesFor(v);
      if (!set.length) return;
      var same = set.length === currentSet.length && set.every(function (s, i) { return s === currentSet[i]; });
      var sw = swiperEl.swiper;
      if (!same) {
        var wrapper = swiperEl.querySelector('.swiper-wrapper');
        if (!wrapper) return;
        currentSet = set;
        allSlides.forEach(function (s) { if (s.parentNode === wrapper) wrapper.removeChild(s); });
        set.forEach(function (s) { wrapper.appendChild(s); });
        // Les images hors ecran sont en lazy : on force celles de la paire.
        set.forEach(function (s) {
          s.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
        });
        if (sw && sw.update) {
          sw.update();
          sw.slideTo(0, 0);
        }
      } else if (sw && sw.slideTo) {
        sw.slideTo(0, 0);
      }
      if (sidesUi) {
        sidesUi.hidden = set.length < 2;
        setSideBtn(0);
      }
    }

    if (sidesUi && hasSides) {
      sidesUi.addEventListener('click', function (e) {
        var b = e.target.closest('[data-lp-side-btn]');
        if (!b) return;
        var idx = parseInt(b.getAttribute('data-lp-side-btn'), 10) || 0;
        var sw = swiperEl.swiper;
        if (sw && sw.slideTo) sw.slideTo(idx);
        setSideBtn(idx);
      });
      // L'instance Swiper arrive en differe : on s'y accroche des
      // qu'elle existe pour suivre le glissement au doigt.
      var tries = 0;
      var hook = setInterval(function () {
        tries++;
        var sw = swiperEl.swiper;
        if (sw && sw.on) {
          clearInterval(hook);
          sw.on('slideChange', function () { setSideBtn(sw.activeIndex || 0); });
        } else if (tries > 40) {
          clearInterval(hook);
        }
      }, 250);
    }

    // --- valeurs nutritives par saveur ------------------------
    // JSON rendu par product-main.liquid depuis la table du theme :
    // { fr: bool, rows: { "Titre de saveur": { facts: [..4], img: url } } }
    var factsData = null;
    try {
      var nj = wrap.querySelector('[data-lp-nutrition]');
      if (nj) factsData = JSON.parse(nj.textContent);
    } catch (e) { factsData = null; }

    function applyFacts(v) {
      if (!factsData || !factsData.rows || !v) return;
      var row = factsData.rows[v.title];
      if (!row) return;

      var facts = row.facts || [];
      wrap.querySelectorAll('[data-lp-fact]').forEach(function (el) {
        var i = parseInt(el.getAttribute('data-lp-fact'), 10);
        var val = facts[i];
        if (val == null || val === '' || el.textContent.trim() === val) return;
        el.classList.add('is-updating');
        el.textContent = val;
        setTimeout(function () { el.classList.remove('is-updating'); }, 400);
      });

      var link = wrap.querySelector('[data-lp-supp-link]');
      var img = wrap.querySelector('[data-lp-supp]');
      var fallback = wrap.querySelector('[data-lp-supp-fallback]');
      if (img) {
        if (row.img) {
          if (img.getAttribute('src') !== row.img) {
            img.removeAttribute('srcset');
            img.src = row.img;
            img.alt = (img.alt || '').replace(/ \u2014 .*$/, '') + ' \u2014 ' + v.title;
          }
          if (link) { link.href = row.img; link.hidden = false; }
          img.hidden = false;
          if (fallback) fallback.hidden = true;
        } else {
          if (link) link.hidden = true;
          img.hidden = true;
          if (fallback) fallback.hidden = false;
        }
      }
    }

    // --- stock honnete ---------------------------------------
    var stockEl = wrap.querySelector('[data-lp-stock]');
    function applyStock(v) {
      if (!stockEl || !v) return;
      var threshold = parseInt(stockEl.getAttribute('data-lp-stock-threshold'), 10) || 5;
      var flavour = v.title === 'Default Title' ? '' : v.title;
      var msg = '';
      var kind = '';

      if (!v.available) {
        msg = stockEl.getAttribute('data-lp-stock-out') || '';
        kind = 'out';
      } else if (v.managed && v.policy !== 'continue' && v.inventory > 0 && v.inventory <= threshold) {
        msg = (stockEl.getAttribute('data-lp-stock-low') || '')
          .replace('[count]', v.inventory)
          .replace('[flavour]', flavour)
          .replace(/\s+in\s*$/, '');
        kind = 'low';
      }

      stockEl.textContent = msg;
      stockEl.hidden = !msg;
      stockEl.classList.toggle('is-low', kind === 'low');
      stockEl.classList.toggle('is-out', kind === 'out');

      // Retour en stock : le formulaire suit la variante choisie.
      var notify = wrap.querySelector('[data-lp-notify]');
      if (notify) {
        notify.hidden = v.available;
        var pv = notify.querySelector('[data-lp-notify-variant]');
        var pu = notify.querySelector('[data-lp-notify-url]');
        var pb = notify.querySelector('[data-lp-notify-body]');
        var pp = notify.querySelector('[data-lp-notify-product]');
        var title = v.title === 'Default Title' ? '' : v.title;
        if (pv) pv.value = title;
        if (pu) pu.value = pu.value.replace(/variant=\d+/, 'variant=' + v.id);
        if (pb && pp) pb.value = 'Back in stock request — ' + pp.value + ' / ' + title;
      }
    }

    // --- profil de saveur ------------------------------------
    var tasteEl = wrap.querySelector('[data-lp-taste]');

    /* Profils par NOM de saveur. Le metafield de variante
       custom.taste garde la priorite s'il est rempli ; sinon on
       tombe ici, et en dernier recours sur le defaut du bloc.
       Un nom de saveur se repete d'un produit a l'autre : une
       seule table couvre tout le catalogue, rien a saisir dans
       l'admin. Cles en minuscules. */
    var TASTE_MAP = {
      'blue raspberry':              { t: 'Sweet:4, Tart:3, Creamy:1', w: 'Candy-sweet, bright, no aftertaste' },
      'peach candy':                 { t: 'Sweet:4, Tart:2, Creamy:1', w: 'Soft peach candy, smooth and easy' },
      'nerdz punch':                 { t: 'Sweet:5, Tart:3, Creamy:1', w: 'Straight out of the candy aisle' },
      'fruit punch':                 { t: 'Sweet:4, Tart:2, Creamy:1', w: 'Classic punch, juicy and clean' },
      'cherry basherz':              { t: 'Sweet:4, Tart:3, Creamy:1', w: 'Bold cherry candy with a sharp edge' },
      'kiwi watermelon':             { t: 'Sweet:3, Tart:3, Creamy:1', w: 'Fresh and juicy, light finish' },
      'pink lemonade':               { t: 'Sweet:3, Tart:4, Creamy:1', w: 'Zesty lemonade with a real pucker' },
      'rocket pop':                  { t: 'Sweet:4, Tart:2, Creamy:1', w: 'Summer popsicle in a shaker' },
      'miami vice':                  { t: 'Sweet:4, Tart:1, Creamy:2', w: 'Pina colada vibes, smooth and tropical' },
      'grape':                       { t: 'Sweet:4, Tart:2, Creamy:1', w: 'Grape candy, sweet and nostalgic' },
      'tropical heaven':             { t: 'Sweet:4, Tart:2, Creamy:1', w: 'Juicy tropical blend, easy drinking' },
      "cookies n' cream":            { t: 'Sweet:4, Tart:0, Creamy:5', w: 'Milkshake-thick, cookie sweetness' },
      'double chocolate':            { t: 'Sweet:4, Tart:0, Creamy:4', w: 'Deep cocoa, dessert-level rich' },
      'smooth vanilla':              { t: 'Sweet:3, Tart:0, Creamy:4', w: 'Clean vanilla, soft and mellow' },
      'coconut island':              { t: 'Sweet:3, Tart:0, Creamy:4', w: 'Creamy coconut, subtly sweet' },
      'maple brown sugar':           { t: 'Sweet:4, Tart:0, Creamy:4', w: 'Warm maple, brown-sugar finish' },
      'chocolate whipped caramel':   { t: 'Sweet:4, Tart:0, Creamy:4', w: 'Chocolate and caramel, whipped smooth' },
      'choco ferrerolicious':        { t: 'Sweet:5, Tart:0, Creamy:4', w: 'Hazelnut-chocolate indulgence' },
      'chocolate peanut butter cup': { t: 'Sweet:4, Tart:0, Creamy:5', w: 'PB cup in a shaker, thick and rich' },
      'coffee chocolate crisp':      { t: 'Sweet:3, Tart:0, Creamy:4', w: 'Mocha notes, lightly sweet' },
      'strawberry banana':           { t: 'Sweet:4, Tart:1, Creamy:3', w: 'Smoothie-style, fruity and creamy' },
      'strawberry':                  { t: 'Sweet:4, Tart:2, Creamy:1', w: 'Ripe strawberry, sweet and simple' },
      'unflavoured':                 { t: 'Sweet:1, Tart:0, Creamy:2', w: 'Neutral \u2014 mixes into anything' },
      'unflavored':                  { t: 'Sweet:1, Tart:0, Creamy:2', w: 'Neutral \u2014 mixes into anything' }
    };
    function flavourTaste(v) {
      if (!v || !v.title) return null;
      return TASTE_MAP[v.title.toLowerCase().trim()] || null;
    }

    function parseTaste(str) {
      // « Sweet:4, Tart:2, Creamy:3 » -> [{label, value}]
      if (!str) return [];
      return str.split(',').map(function (pair) {
        var bits = pair.split(':');
        var val = parseInt((bits[1] || '').trim(), 10);
        return { label: (bits[0] || '').trim(), value: isNaN(val) ? 0 : Math.max(0, Math.min(5, val)) };
      }).filter(function (t) { return t.label; });
    }
    function applyTaste(v) {
      if (!tasteEl) return;
      var mapped = flavourTaste(v);
      var profile = (v && v.taste) || (mapped && mapped.t) || tasteEl.getAttribute('data-lp-taste-default') || '';
      var words = (v && v.taste_words) || (mapped && mapped.w) || tasteEl.getAttribute('data-lp-taste-words') || '';
      var bars = tasteEl.querySelector('[data-lp-taste-bars]');
      var wordsEl = tasteEl.querySelector('[data-lp-taste-words]');
      var items = parseTaste(profile);

      tasteEl.hidden = !items.length && !words;
      if (bars) {
        bars.innerHTML = '';
        items.forEach(function (t) {
          var row = document.createElement('div');
          row.className = 'lp-taste-profile__row';
          var lab = document.createElement('span');
          lab.className = 'lp-taste-profile__label';
          lab.textContent = t.label;
          var track = document.createElement('span');
          track.className = 'lp-taste-profile__track';
          for (var i = 1; i <= 5; i++) {
            var seg = document.createElement('i');
            if (i <= t.value) seg.className = 'is-on';
            seg.style.transitionDelay = (i * 40) + 'ms';
            track.appendChild(seg);
          }
          row.appendChild(lab);
          row.appendChild(track);
          bars.appendChild(row);
        });
      }
      if (wordsEl) wordsEl.textContent = words;
    }

    // --- extrait d'avis en rotation --------------------------
    var quote = wrap.querySelector('[data-lp-quote]');
    if (quote) {
      var qItems = Array.prototype.slice.call(quote.querySelectorAll('.lp-quote__item'));
      if (qItems.length > 1 && !reduced) {
        var qi = 0;
        setInterval(function () {
          qItems[qi].classList.remove('is-active');
          qi = (qi + 1) % qItems.length;
          qItems[qi].classList.add('is-active');
        }, 6500);
      }
    }

    // --- complete ta stack -----------------------------------
    var stackTotal = wrap.querySelector('[data-lp-stack-total]');
    function applyStackTotal(v) {
      if (!stackTotal || !v) return;
      var extra = parseInt(stackTotal.getAttribute('data-lp-stack-extra'), 10) || 0;
      var cents = (v.price_cents || 0) + extra;
      // Meme format que le prix de la variante : on remplace juste
      // les chiffres pour garder le symbole et la devise du theme.
      var sample = v.price || '';
      var num = (cents / 100).toFixed(2);
      stackTotal.textContent = sample.replace(/[\d.,]+/, num);
    }

    var stackBtn = wrap.querySelector('[data-lp-stack-add]');
    if (stackBtn) {
      stackBtn.addEventListener('click', function () {
        var current = currentVariantId();
        var ids = Array.prototype.slice.call(wrap.querySelectorAll('[data-lp-stack-variant]'))
          .map(function (a) { return a.getAttribute('data-lp-stack-variant'); });
        if (current) ids.unshift(current);
        if (!ids.length || stackBtn.classList.contains('is-busy')) return;

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        stackBtn.classList.add('is-busy');
        window.dispatchEvent(new Event('dynamic-cart-loading'));

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }),
            sections: 'cart-main,header,announcement-bar'
          })
        }).then(function (r) { return r.json(); }).then(function (res) {
          stackBtn.classList.remove('is-busy');
          if (res && res.status && res.status !== 200) {
            if (window.toast && window.toast.error) window.toast.error({ message: res.message || res.description, icon: false });
            return;
          }
          // Memes evenements que le formulaire du theme : le tiroir
          // se rafraichit et s'ouvre.
          window.dispatchEvent(new CustomEvent('ajax-cart', { detail: { cartSections: res.sections } }));
          window.dispatchEvent(new Event('dynamic-cart-open'));
          stackBtn.classList.add('is-done');
          setTimeout(function () { stackBtn.classList.remove('is-done'); }, 2500);
        }).catch(function () {
          stackBtn.classList.remove('is-busy');
        });
      });
    }

    // Le script du theme met a jour le select cache apres le
    // change du swatch : on attend un tick avant de lire.
    wrap.addEventListener('change', function (e) {
      if (!e.target.closest('.product-form__option, .swatches__swatch, select[name="id"]')) return;
      setTimeout(applyVariant, 60);
    });

    // Etat initial : lueur de la saveur deja choisie, stock et
    // profil de la variante courante, sans animer la galerie.
    var initial = swatchColor();
    if (initial) {
      wrap.style.setProperty('--lp-swatch-glow', initial);
      if (bar) bar.style.setProperty('--lp-swatch-glow', initial);
    }
    var v0 = findVariant(currentVariantId());
    applyStock(v0);
    applyTaste(v0);
    applyStackTotal(v0);
    applyFacts(v0);
    applyGallery(v0);
  }

  /* ----------------------------------------------------------
     9. COLLECTION : ONGLETS, SAVEURS SUR LA CARTE, AJOUT DIRECT
     - Les onglets ne rechargent rien : toutes les grilles sont
       rendues, on n'en montre qu'une.
     - Une pastille de saveur change l'image, le nom, le prix et
       l'id vise par le formulaire de la carte.
     - L'ajout passe par /cart/add.js avec les memes sections et
       les memes evenements que le formulaire du theme, donc le
       tiroir se rafraichit et s'ouvre.
     ---------------------------------------------------------- */
  function bindCollection(root) {
    var scope = root || document;

    // --- onglets ---------------------------------------------
    scope.querySelectorAll('[data-lp-coll-tabs]').forEach(function (tabs) {
      if (tabs.dataset.lpBound === 'on') return;
      tabs.dataset.lpBound = 'on';

      var wrap = tabs.closest('.lp-coll');
      var panels = wrap ? wrap.querySelectorAll('[data-lp-coll-panel]') : [];

      tabs.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-lp-coll-tab]');
        if (!btn) return;
        var id = btn.getAttribute('data-lp-coll-tab');

        tabs.querySelectorAll('[data-lp-coll-tab]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        panels.forEach(function (p) {
          // Le panneau « all » est une grille continue de tous les
          // produits ; les panneaux de categorie sont exclusifs.
          // Les deux ne coexistent jamais a l'ecran.
          var isAll = p.getAttribute('data-lp-coll-panel') === 'all';
          var show = id === 'all' ? isAll : p.getAttribute('data-lp-coll-panel') === id;
          p.hidden = !show;
          if (show) {
            p.classList.remove('is-in');
            void p.offsetWidth;
            p.classList.add('is-in');
          }
        });
      });
    });

    // --- carte double : interrupteur de format ---------------
    scope.querySelectorAll('[data-lp-pair]').forEach(function (pair) {
      if (pair.dataset.lpBound === 'on') return;
      pair.dataset.lpBound = 'on';

      pair.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-lp-pair-btn]');
        if (!btn) return;
        var key = btn.getAttribute('data-lp-pair-btn');

        pair.querySelectorAll('[data-lp-pair-btn]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        pair.querySelectorAll('[data-lp-pair-slot]').forEach(function (s) {
          s.hidden = s.getAttribute('data-lp-pair-slot') !== key;
        });
      });
    });

    // --- saveurs sur la carte --------------------------------
    scope.querySelectorAll('[data-lp-card]').forEach(function (card) {
      if (card.dataset.lpBound === 'on') return;
      card.dataset.lpBound = 'on';

      var img = card.querySelector('[data-lp-card-img]');
      var link = card.querySelector('[data-lp-card-link]');
      var name = card.querySelector('[data-lp-card-variant-name]');
      var dot = card.querySelector('.lp-card__variant-dot');
      var now = card.querySelector('[data-lp-card-now]');
      var was = card.querySelector('[data-lp-card-was]');
      var price = card.querySelector('[data-lp-card-price]');
      var idInput = card.querySelector('[data-lp-card-id]');
      var add = card.querySelector('[data-lp-card-add]');
      var addLabel = card.querySelector('[data-lp-card-add-label]');
      var handle = card.getAttribute('data-lp-card-handle');
      var soldLabel = null;
      var per = card.querySelector('[data-lp-card-per]');

      // Video de survol : chargee au premier survol seulement.
      var vid = card.querySelector('[data-lp-card-video]');
      if (vid && !reduced && !coarse) {
        card.addEventListener('pointerenter', function () {
          if (!vid.src) vid.src = vid.getAttribute('data-src');
          var pl = vid.play();
          if (pl && pl.catch) pl.catch(function () {});
          card.classList.add('is-playing');
        });
        card.addEventListener('pointerleave', function () {
          vid.pause();
          card.classList.remove('is-playing');
        });
      }

      // Couleur de la saveur active au chargement.
      var first = card.querySelector('.lp-card__swatch.is-active');
      if (first) card.style.setProperty('--lp-card-color', first.style.getPropertyValue('--lp-chip').trim());

      card.addEventListener('click', function (e) {
        var sw = e.target.closest('[data-lp-card-swatch]');
        if (!sw) return;
        e.preventDefault();

        card.querySelectorAll('[data-lp-card-swatch]').forEach(function (b) {
          var on = b === sw;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });

        var id = sw.getAttribute('data-lp-card-swatch');
        var title = sw.getAttribute('data-lp-v-title') || '';
        var vPrice = sw.getAttribute('data-lp-v-price') || '';
        var vWas = sw.getAttribute('data-lp-v-was') || '';
        var vImg = sw.getAttribute('data-lp-v-image') || '';
        var avail = sw.getAttribute('data-lp-v-available') === 'true';
        var color = sw.style.getPropertyValue('--lp-chip').trim();

        card.style.setProperty('--lp-card-color', color);
        if (name) name.textContent = title;
        if (dot) dot.style.background = color;
        if (now) now.textContent = vPrice;

        // Prix par portion : recalcule sur la variante choisie.
        if (per) {
          var servings = parseInt(per.getAttribute('data-lp-servings'), 10) || 0;
          var cents = parseInt(sw.getAttribute('data-lp-v-cents'), 10) || 0;
          if (servings > 0 && cents > 0) {
            per.textContent = vPrice.replace(/[\d.,]+/, (cents / 100 / servings).toFixed(2)) + ' / serving';
          }
        }

        // Prix barre : on le cree ou on le retire selon la variante.
        if (vWas) {
          if (!was && price) {
            was = document.createElement('s');
            was.setAttribute('data-lp-card-was', '');
            price.insertBefore(was, price.firstChild);
          }
          if (was) { was.textContent = vWas; was.hidden = false; }
        } else if (was) {
          was.hidden = true;
        }

        if (vImg && img) {
          img.classList.add('is-swapping');
          img.src = vImg;
          img.removeAttribute('srcset');
          setTimeout(function () { img.classList.remove('is-swapping'); }, 450);
        }

        var url = '/products/' + handle + '?variant=' + id;
        if (link) link.href = url;
        var titleLink = card.querySelector('[data-lp-card-title-link]');
        if (titleLink) titleLink.href = url;

        if (idInput) idInput.value = id;
        if (add) {
          add.disabled = !avail;
          if (addLabel) {
            if (!soldLabel && !avail) soldLabel = addLabel.getAttribute('data-sold') || addLabel.textContent;
            addLabel.textContent = avail
              ? (addLabel.getAttribute('data-add') || addLabel.textContent)
              : (addLabel.getAttribute('data-sold') || 'Sold out');
          }
        }
        // Epuise : le bouton d'ajout s'efface au profit de
        // « Notify me », qui ouvre l'apercu ou vit le formulaire.
        var notifyBtn = card.querySelector('[data-lp-card-notify]');
        var form2 = card.querySelector('[data-lp-card-form]');
        if (notifyBtn) notifyBtn.hidden = avail;
        if (form2) form2.hidden = !avail;
        card.classList.toggle('is-sold-out', !avail);
      });

      // Memoriser les deux libelles du bouton des le depart.
      if (addLabel && !addLabel.getAttribute('data-add')) {
        var initialAvailable = add && !add.disabled;
        addLabel.setAttribute('data-add', initialAvailable ? addLabel.textContent.trim() : 'Add to cart');
        addLabel.setAttribute('data-sold', initialAvailable ? 'Sold out' : addLabel.textContent.trim());
      }

      // --- ajout au panier -----------------------------------
      var form = card.querySelector('[data-lp-card-form]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!add || add.disabled || add.classList.contains('is-busy')) return;

          var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          add.classList.add('is-busy');
          window.dispatchEvent(new Event('dynamic-cart-loading'));

          fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id: parseInt(idInput.value, 10), quantity: 1 }],
              sections: 'cart-main,header,announcement-bar'
            })
          }).then(function (r) { return r.json(); }).then(function (res) {
            add.classList.remove('is-busy');
            if (res && res.status && res.status !== 200) {
              if (window.toast && window.toast.error) window.toast.error({ message: res.message || res.description, icon: false });
              return;
            }
            window.dispatchEvent(new CustomEvent('ajax-cart', { detail: { cartSections: res.sections } }));
            window.dispatchEvent(new Event('dynamic-cart-open'));
            add.classList.add('is-done');
            setTimeout(function () { add.classList.remove('is-done'); }, 1800);
          }).catch(function () {
            add.classList.remove('is-busy');
          });
        });
      }
    });
  }

  /* ----------------------------------------------------------
     10. COLLECTION : FILTRE SAVEUR, COMPARATEUR, APERCU RAPIDE
     ---------------------------------------------------------- */

  // --- filtre par saveur -------------------------------------
  function bindFlavourBar(root) {
    var bar = (root || document).querySelector('[data-lp-flavourbar]');
    if (!bar || bar.dataset.lpBound === 'on') return;

    var list = bar.querySelector('[data-lp-flavourbar-list]');
    var clear = bar.querySelector('[data-lp-flavourbar-clear]');
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-lp-card]'));
    if (!list || !cards.length) return;
    bar.dataset.lpBound = 'on';

    // Inventaire des saveurs presentes, avec leur couleur : on la
    // reprend de la premiere pastille rencontree pour ce nom.
    var flavours = {};
    cards.forEach(function (card) {
      card.querySelectorAll('[data-lp-card-swatch]').forEach(function (sw) {
        var name = (sw.getAttribute('data-lp-v-title') || '').trim();
        var key = name.toLowerCase();
        if (!key || key === 'default title') return;
        if (!flavours[key]) {
          flavours[key] = { name: name, color: sw.style.getPropertyValue('--lp-chip').trim(), count: 0 };
        }
        flavours[key].count++;
      });
    });

    var keys = Object.keys(flavours).sort(function (a, b) {
      return flavours[b].count - flavours[a].count;
    });
    if (keys.length < 2) return;

    keys.forEach(function (key) {
      var f = flavours[key];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lp-flavourbar__chip';
      b.setAttribute('data-lp-flavour', key);
      b.style.setProperty('--lp-chip', f.color || '#9AA0A6');
      b.innerHTML = '<i aria-hidden="true"></i><span></span>';
      b.querySelector('span').textContent = f.name;
      list.appendChild(b);
    });

    bar.hidden = false;

    function apply(key) {
      cards.forEach(function (card) {
        var host = card.closest('[data-lp-pair]') || card;
        if (!key) {
          host.hidden = false;
          card.classList.remove('is-filtered');
          return;
        }
        var has = (card.getAttribute('data-lp-flavours') || '').indexOf(key + '|') !== -1;
        host.hidden = !has;
        card.classList.toggle('is-filtered', has);

        // Positionner la carte sur la saveur demandee.
        if (has) {
          var target = null;
          card.querySelectorAll('[data-lp-card-swatch]').forEach(function (sw) {
            if ((sw.getAttribute('data-lp-v-title') || '').toLowerCase() === key) target = sw;
          });
          if (target && !target.classList.contains('is-active')) target.click();
        }
      });

      // Un titre de groupe dont toutes les cartes sont masquees
      // n'a plus lieu d'etre affiche.
      document.querySelectorAll('.lp-coll__grid--all > .lp-coll__group').forEach(function (h) {
        var any = false;
        var n = h.nextElementSibling;
        while (n && !n.classList.contains('lp-coll__group')) {
          if (!n.hidden) any = true;
          n = n.nextElementSibling;
        }
        h.hidden = !any;
      });

      if (clear) clear.hidden = !key;
    }

    bar.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-lp-flavour]');
      if (chip) {
        var on = !chip.classList.contains('is-active');
        list.querySelectorAll('[data-lp-flavour]').forEach(function (c) {
          c.classList.toggle('is-active', c === chip && on);
        });
        apply(on ? chip.getAttribute('data-lp-flavour') : null);
        return;
      }
      if (e.target.closest('[data-lp-flavourbar-clear]')) {
        list.querySelectorAll('[data-lp-flavour]').forEach(function (c) { c.classList.remove('is-active'); });
        apply(null);
      }
    });
  }

  // --- comparateur -------------------------------------------
  function bindCompare(root) {
    var box = (root || document).querySelector('[data-lp-compare]');
    if (!box || box.dataset.lpBound === 'on') return;
    box.dataset.lpBound = 'on';

    var thumbs = box.querySelector('[data-lp-compare-thumbs]');
    var countEl = box.querySelector('[data-lp-compare-count]');
    var sheet = box.querySelector('[data-lp-compare-sheet]');
    var table = box.querySelector('[data-lp-compare-table]');
    var picked = [];
    var MAX = 3;

    function sync() {
      box.hidden = picked.length === 0;
      if (countEl) countEl.textContent = picked.length + '/' + MAX;
      if (thumbs) {
        thumbs.innerHTML = '';
        picked.forEach(function (card) {
          var img = card.querySelector('[data-lp-card-img]');
          var t = document.createElement('span');
          t.className = 'lp-compare__thumb';
          if (img) {
            var i = document.createElement('img');
            i.src = img.currentSrc || img.src;
            i.alt = '';
            t.appendChild(i);
          }
          thumbs.appendChild(t);
        });
      }
    }

    document.addEventListener('change', function (e) {
      var cb = e.target.closest('[data-lp-card-compare]');
      if (!cb) return;
      var card = cb.closest('[data-lp-card]');
      if (!card) return;

      if (cb.checked) {
        if (picked.length >= MAX) {
          cb.checked = false;
          return;
        }
        picked.push(card);
      } else {
        picked = picked.filter(function (c) { return c !== card; });
      }
      card.classList.toggle('is-comparing', cb.checked);
      sync();
    });

    function rowsFor(card) {
      var sw = card.querySelector('.lp-card__swatch.is-active');
      var per = card.querySelector('[data-lp-card-per]');
      var flav = card.querySelectorAll('[data-lp-card-swatch]').length;
      return {
        title: card.getAttribute('data-lp-card-title') || '',
        url: card.getAttribute('data-lp-card-url') || '#',
        img: (card.querySelector('[data-lp-card-img]') || {}).src || '',
        price: (card.querySelector('[data-lp-card-now]') || {}).textContent || '',
        per: per ? per.textContent : '—',
        flavour: sw ? sw.getAttribute('data-lp-v-title') : '—',
        flavours: flav ? flav + '' : '1',
        stock: card.classList.contains('is-sold-out') ? 'Sold out' : 'In stock'
      };
    }

    function build() {
      if (!table) return;
      var data = picked.map(rowsFor);
      var labels = [
        ['price', 'Price'],
        ['per', 'Per serving'],
        ['flavour', 'Selected flavour'],
        ['flavours', 'Flavours'],
        ['stock', 'Availability']
      ];

      var html = '<div class="lp-compare__cols" style="--n:' + data.length + '">';
      html += '<div class="lp-compare__row lp-compare__row--head"><span></span>';
      data.forEach(function (d) {
        html += '<a class="lp-compare__card" href="' + d.url + '">' +
                (d.img ? '<img src="' + d.img + '" alt="">' : '') +
                '<strong></strong></a>';
      });
      html += '</div>';

      labels.forEach(function (pair) {
        html += '<div class="lp-compare__row"><span>' + pair[1] + '</span>';
        data.forEach(function () { html += '<b></b>'; });
        html += '</div>';
      });
      html += '</div>';
      table.innerHTML = html;

      // Les valeurs sont posees en textContent : aucun contenu
      // produit n'est injecte en HTML.
      var heads = table.querySelectorAll('.lp-compare__card strong');
      data.forEach(function (d, i) { if (heads[i]) heads[i].textContent = d.title; });

      var rows = table.querySelectorAll('.lp-compare__row:not(.lp-compare__row--head)');
      labels.forEach(function (pair, r) {
        var cells = rows[r] ? rows[r].querySelectorAll('b') : [];
        data.forEach(function (d, i) { if (cells[i]) cells[i].textContent = d[pair[0]]; });
      });
    }

    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-lp-compare-open]')) {
        build();
        if (sheet) sheet.hidden = false;
        box.classList.add('is-open');
      } else if (e.target.closest('[data-lp-compare-close]')) {
        if (sheet) sheet.hidden = true;
        box.classList.remove('is-open');
      } else if (e.target.closest('[data-lp-compare-clear]')) {
        picked.forEach(function (card) {
          var cb = card.querySelector('[data-lp-card-compare]');
          if (cb) cb.checked = false;
          card.classList.remove('is-comparing');
        });
        picked = [];
        if (sheet) sheet.hidden = true;
        box.classList.remove('is-open');
        sync();
      }
    });
  }

  // --- apercu rapide -----------------------------------------
  function bindPeek(root) {
    var peek = (root || document).querySelector('[data-lp-peek]');
    if (!peek || peek.dataset.lpBound === 'on') return;
    peek.dataset.lpBound = 'on';

    var body = peek.querySelector('[data-lp-peek-body]');

    function close() {
      peek.hidden = true;
      peek.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      // Le bouton « Notify me » des cartes ouvre le meme panneau :
      // le formulaire de retour en stock y est deja rendu.
      var btn = e.target.closest('[data-lp-card-peek], [data-lp-card-notify]');
      if (!btn) return;
      var card = btn.closest('[data-lp-card]');
      if (!card || !body) return;

      var url = card.getAttribute('data-lp-card-url');
      var sw = card.querySelector('.lp-card__swatch.is-active');
      var id = sw ? sw.getAttribute('data-lp-card-swatch') : null;

      peek.hidden = false;
      peek.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      body.innerHTML = '<div class="lp-peek__loading"></div>';

      // Gabarit dedie : product.lp-peek (balisage nu, sans le
      // tiroir ferme du quick-add du theme).
      fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'view=lp-peek' + (id ? '&variant=' + id : ''))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          body.innerHTML = html;
          // Rebrancher ce qui vit dans le contenu injecte.
          if (window.Shopify && window.Shopify.PaymentButton) {
            try { window.Shopify.PaymentButton.init(); } catch (e) {}
          }
        })
        .catch(function () {
          body.innerHTML = '';
          window.location.href = url;
        });
    });

    peek.addEventListener('click', function (e) {
      if (e.target.closest('[data-lp-peek-close]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !peek.hidden) close();
    });
  }

  /* ----------------------------------------------------------
     11. BARRE DE PANIER COLLANTE
     Apparait des qu'il y a quelque chose dans le panier. Le
     total et le nombre d'articles sont relus a chaque
     evenement ajax-cart du theme, plus une lecture initiale.
     ---------------------------------------------------------- */
  function bindCartBar() {
    var bar = document.querySelector('[data-lp-cartbar]');
    if (!bar || bar.dataset.lpBound === 'on') return;
    bar.dataset.lpBound = 'on';

    var countEl = bar.querySelector('[data-lp-cartbar-count]');
    var totalEl = bar.querySelector('[data-lp-cartbar-total]');
    var msgEl = bar.querySelector('[data-lp-cartbar-msg]');
    var fillEl = bar.querySelector('[data-lp-cartbar-fill]');
    var threshold = parseInt(bar.getAttribute('data-lp-threshold'), 10) || 0;

    function money(cents) {
      var s = bar.getAttribute('data-lp-money') || '${{amount}}';
      return s.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
    }

    function render(cart) {
      if (!cart) return;
      var n = cart.item_count || 0;
      bar.classList.toggle('is-visible', n > 0);
      if (countEl) countEl.textContent = n + (n === 1 ? ' item' : ' items');
      if (totalEl) totalEl.textContent = money(cart.total_price || 0);

      if (threshold > 0) {
        var left = threshold - (cart.total_price || 0);
        var pct = Math.min(100, Math.round(((cart.total_price || 0) / threshold) * 100));
        if (fillEl) fillEl.style.width = pct + '%';
        if (msgEl) {
          msgEl.textContent = left > 0
            ? 'Add ' + money(left) + ' for free shipping'
            : 'Free shipping unlocked';
          msgEl.classList.toggle('is-done', left <= 0);
        }
      }
    }

    function refresh() {
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(rootUrl + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }

    window.addEventListener('ajax-cart', function () { setTimeout(refresh, 120); });
    refresh();
  }

  /* ----------------------------------------------------------
     12. CONSTRUCTEUR DE STACK
     Un choix par etape ; le total suit. Le bouton ajoute tout
     en une requete, avec les memes evenements que le reste.
     ---------------------------------------------------------- */
  function bindBuilder() {
    var b = document.querySelector('[data-lp-builder]');
    if (!b || b.dataset.lpBound === 'on') return;
    b.dataset.lpBound = 'on';

    var totalEl = b.querySelector('[data-lp-builder-total]');
    var noteEl = b.querySelector('[data-lp-builder-note]');
    var add = b.querySelector('[data-lp-builder-add]');
    var slots = Array.prototype.slice.call(b.querySelectorAll('[data-lp-slot]'));

    function money(cents) {
      var s = b.getAttribute('data-lp-money') || '${{amount}}';
      return s.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
    }

    function chosen() {
      return slots.map(function (s) { return s.querySelector('[data-lp-pick].is-active'); })
                  .filter(Boolean);
    }

    function sync() {
      var picks = chosen();
      var cents = picks.reduce(function (sum, p) {
        return sum + (parseInt(p.getAttribute('data-lp-pick-cents'), 10) || 0);
      }, 0);

      if (totalEl) totalEl.textContent = picks.length ? money(cents) : '\u2014';
      if (noteEl) {
        noteEl.textContent = picks.length
          ? picks.length + ' of ' + slots.length + ' steps picked'
          : 'Pick one from each step';
      }
      if (add) add.disabled = picks.length === 0;
    }

    b.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-lp-pick]');
      if (pick) {
        var slot = pick.closest('[data-lp-slot]');
        var already = pick.classList.contains('is-active');
        slot.querySelectorAll('[data-lp-pick]').forEach(function (p) { p.classList.remove('is-active'); });
        // Recliquer le meme choix le retire : on peut sauter une
        // etape sans avoir a recharger la page.
        if (!already) pick.classList.add('is-active');
        sync();
        return;
      }

      if (e.target.closest('[data-lp-builder-add]')) {
        var picks = chosen();
        if (!picks.length || add.classList.contains('is-busy')) return;

        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        add.classList.add('is-busy');
        window.dispatchEvent(new Event('dynamic-cart-loading'));

        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: picks.map(function (p) {
              return { id: parseInt(p.getAttribute('data-lp-pick-id'), 10), quantity: 1 };
            }),
            sections: 'cart-main,header,announcement-bar'
          })
        }).then(function (r) { return r.json(); }).then(function (res) {
          add.classList.remove('is-busy');
          if (res && res.status && res.status !== 200) {
            if (window.toast && window.toast.error) window.toast.error({ message: res.message || res.description, icon: false });
            return;
          }
          window.dispatchEvent(new CustomEvent('ajax-cart', { detail: { cartSections: res.sections } }));
          window.dispatchEvent(new Event('dynamic-cart-open'));
          add.classList.add('is-done');
          setTimeout(function () { add.classList.remove('is-done'); }, 2200);
        }).catch(function () {
          add.classList.remove('is-busy');
        });
      }
    });

    sync();
  }

  /* ----------------------------------------------------------
     13. CARTE DES POINTS DE VENTE
     Leaflet + tuiles CARTO, donnees depuis assets/lp-stores.json.
     Tout est charge a la demande : rien de tout ca ne part sur
     les autres pages.
     ---------------------------------------------------------- */
  var LP_STORES_CACHE = null;

  /* Compteurs verifiables n'importe ou sur le site.
     Tout element portant data-lp-stat="stores|provinces|cities"
     recoit le vrai chiffre de lp-stores.json, a condition qu'un
     conteneur porte data-lp-stores-live. Liquid ne sait pas lire
     un fichier de assets/, d'où le passage par le reseau.
     Si le fetch echoue, les nombres rendus par Liquid restent :
     on ne casse jamais l'affichage pour un compteur. */
  function bindStoreStats() {
    var host = document.querySelector('[data-lp-stores-live]');
    if (!host || host.dataset.lpStatsBound === 'on') return;
    host.dataset.lpStatsBound = 'on';

    function fill(data) {
      var values = {
        stores: data.count,
        provinces: (data.provinces || []).length,
        cities: data.cities
      };
      document.querySelectorAll('[data-lp-stat]').forEach(function (node) {
        var value = values[node.getAttribute('data-lp-stat')];
        if (value !== undefined && value !== null && value !== '') {
          node.textContent = value;
        }
      });
    }

    lpLoadStores(host.getAttribute('data-lp-stores-src'))
      .then(function (data) { fill(lpStoresData(data)); })
      .catch(function () {});
  }

  function lpLoadCss(href) {
    if (!href || document.querySelector('link[href="' + href + '"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function lpLoadJs(src) {
    return new Promise(function (resolve, reject) {
      if (!src) return reject(new Error('no src'));
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.dataset.lpLoaded === 'on') return resolve();
        existing.addEventListener('load', function () { resolve(); });
        existing.addEventListener('error', reject);
        return;
      }
      var script = document.createElement('script');
      script.src = src;
      script.addEventListener('load', function () {
        script.dataset.lpLoaded = 'on';
        resolve();
      });
      script.addEventListener('error', reject);
      document.head.appendChild(script);
    });
  }

  function lpNorm(value) {
    return (value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  /* Distance a vol d'oiseau, en km. Suffisant pour classer des
     magasins : on n'a pas besoin d'un itineraire routier. */
  function lpDistance(lat1, lng1, lat2, lng2) {
    var toRad = Math.PI / 180;
    var dLat = (lat2 - lat1) * toRad;
    var dLng = (lng2 - lng1) * toRad;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function lpIsApple() {
    return /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent);
  }

  function lpDirectionsUrl(store) {
    var q = encodeURIComponent(
      store.name + ', ' + store.address + ', ' + store.city + ', ' + store.prov +
      (store.postal ? ' ' + store.postal : '')
    );
    return lpIsApple()
      ? 'https://maps.apple.com/?daddr=' + q
      : 'https://www.google.com/maps/dir/?api=1&destination=' + q;
  }

  function bindStoreMap() {
    var root = document.querySelector('[data-lp-map]');
    if (!root || root.dataset.lpBound === 'on') return;
    root.dataset.lpBound = 'on';

    var configNode = root.querySelector('[data-lp-map-config]');
    var cfg = {};
    try {
      cfg = JSON.parse(configNode ? configNode.textContent : '{}');
    } catch (e) {
      cfg = {};
    }

    var canvas = root.querySelector('[data-lp-map-canvas]');
    var listEl = root.querySelector('[data-lp-map-list]');
    var countEl = root.querySelector('[data-lp-map-count]');
    var emptyEl = root.querySelector('[data-lp-map-empty]');
    var moreBtn = root.querySelector('[data-lp-map-more]');
    var input = root.querySelector('[data-lp-map-search]');
    var nearBtn = root.querySelector('[data-lp-map-near]');
    var areaToggle = root.querySelector('[data-lp-map-area]');
    var chipWrap = root.querySelector('[data-lp-map-chips]');
    var statTotal = root.querySelector('[data-lp-map-stat="total"]');
    var statProv = root.querySelector('[data-lp-map-stat="prov"]');
    var statCity = root.querySelector('[data-lp-map-stat="city"]');
    var statusEl = root.querySelector('[data-lp-map-status]');

    var PAGE = 30;
    var stores = [];
    var filtered = [];
    var shown = 0;
    var activeProv = '';
    var origin = null;          // position du visiteur
    var map = null;
    var cluster = null;
    var markers = {};           // id -> marker
    var boundsOnly = false;
    var cards = {};             // id -> element

    function say(message) {
      if (statusEl) statusEl.textContent = message || '';
    }

    /* ---------------------------------------------------- rendu */

    function distanceLabel(store) {
      if (!origin || typeof store._d !== 'number') return '';
      return store._d < 10
        ? store._d.toFixed(1).replace('.', ',') + ' km'
        : Math.round(store._d) + ' km';
    }

    function buildCard(store) {
      var li = document.createElement('li');
      li.className = 'lp-map__card';
      li.setAttribute('data-lp-map-card', store.id);
      li.setAttribute('tabindex', '0');

      var dist = distanceLabel(store);
      var head = '<div class="lp-map__card-head">' +
        '<h3 class="lp-map__card-name"></h3>' +
        (dist ? '<span class="lp-map__card-dist">' + dist + '</span>' : '') +
        '</div>';

      li.innerHTML = head +
        '<p class="lp-map__card-addr"></p>' +
        '<div class="lp-map__card-actions">' +
          '<a class="lp-map__card-link" target="_blank" rel="noopener"></a>' +
        '</div>';

      // textContent plutot que de l'interpolation : les noms
      // contiennent des apostrophes et des accents.
      li.querySelector('.lp-map__card-name').textContent = store.name;
      li.querySelector('.lp-map__card-addr').textContent =
        store.address + ', ' + store.city + ', ' + store.prov +
        (store.postal ? ' ' + store.postal : '');

      var link = li.querySelector('.lp-map__card-link');
      link.href = lpDirectionsUrl(store);
      link.textContent = cfg.directionsLabel || 'Itineraire';

      /* Telephone et site web : uniquement sur les fiches
         saisies dans l'editeur de theme. */
      if (store.phone) {
        var tel = document.createElement('a');
        tel.className = 'lp-map__card-link';
        tel.href = 'tel:' + String(store.phone).replace(/[^0-9+]/g, '');
        tel.textContent = store.phone;
        li.querySelector('.lp-map__card-actions').appendChild(tel);
      }

      if (store.website) {
        var site = document.createElement('a');
        site.className = 'lp-map__card-link';
        site.href = store.website;
        site.target = '_blank';
        site.rel = 'noopener';
        site.textContent = cfg.websiteLabel || 'Site web';
        li.querySelector('.lp-map__card-actions').appendChild(site);
      }

      /* Signalement d'erreur. Un tiers des fiches vient d'une
         liste jamais revalidee : autant laisser les clients
         nous corriger. Le courriel part pre-rempli avec
         l'identifiant, qui se retrouve tel quel dans le
         fichier Excel. */
      if (cfg.reportEmail) {
        var report = document.createElement('a');
        report.className = 'lp-map__card-report';
        report.href = 'mailto:' + cfg.reportEmail +
          '?subject=' + encodeURIComponent(cfg.reportSubject || 'Store locator correction') +
          '&body=' + encodeURIComponent(
            (cfg.reportBody || '') + '\n\n' +
            store.name + '\n' +
            store.address + ', ' + store.city + ', ' + store.prov + '\n' +
            'ref: ' + store.id + '\n\n'
          );
        report.textContent = cfg.reportLabel || 'Report an error';
        li.querySelector('.lp-map__card-actions').appendChild(report);
      }

      /* Filet de securite pour l'employe : le probleme s'affiche
         dans l'editeur de theme, jamais pour le client. */
      if (store._warn && window.Shopify && window.Shopify.designMode) {
        var warn = document.createElement('p');
        warn.className = 'lp-map__card-warn';
        warn.textContent = '\u26a0\ufe0e ' + store._warn;
        li.appendChild(warn);
      }

      return li;
    }

    function renderChunk() {
      if (!listEl) return;
      var slice = filtered.slice(shown, shown + PAGE);
      var frag = document.createDocumentFragment();
      slice.forEach(function (store) {
        var card = buildCard(store);
        cards[store.id] = card;
        frag.appendChild(card);
      });
      listEl.appendChild(frag);
      shown += slice.length;
      if (moreBtn) moreBtn.hidden = shown >= filtered.length;
    }

    function renderList() {
      if (!listEl) return;
      listEl.innerHTML = '';
      cards = {};
      shown = 0;
      renderChunk();

      if (countEl) {
        var one = cfg.countSingular || 'point de vente';
        var many = cfg.countPlural || 'points de vente';
        countEl.textContent = filtered.length + ' ' + (filtered.length === 1 ? one : many);
      }
      if (emptyEl) emptyEl.hidden = filtered.length !== 0;
    }

    /* -------------------------------------------------- filtrage */

    function matches(store, term) {
      if (activeProv && store.prov !== activeProv) return false;
      if (boundsOnly && map && store.lat != null) {
        if (!map.getBounds().contains([store.lat, store.lng])) return false;
      }
      if (!term) return true;
      return store._hay.indexOf(term) !== -1;
    }

    function apply() {
      var term = lpNorm(input ? input.value : '');
      filtered = stores.filter(function (store) { return matches(store, term); });

      if (origin) {
        filtered.sort(function (a, b) {
          if (typeof a._d !== 'number') return 1;
          if (typeof b._d !== 'number') return -1;
          return a._d - b._d;
        });
      }

      renderList();
      syncMarkers();
    }

    /* ----------------------------------------------------- carte */

    function pinIcon(store) {
      return window.L.divIcon({
        className: 'lp-pin' + (store.check ? ' lp-pin--check' : ''),
        html: '<span class="lp-pin__dot"></span>',
        iconSize: [18, 18],
        iconAnchor: [9, 9]
      });
    }

    function popupHtml(store) {
      var wrap = document.createElement('div');
      wrap.className = 'lp-map__pop';
      wrap.innerHTML = '<strong></strong><span></span>' +
        '<a target="_blank" rel="noopener"></a>';
      wrap.querySelector('strong').textContent = store.name;
      wrap.querySelector('span').textContent =
        store.address + ', ' + store.city;
      var a = wrap.querySelector('a');
      a.href = lpDirectionsUrl(store);
      a.textContent = cfg.directionsLabel || 'Itineraire';
      return wrap;
    }

    function highlight(id, pan) {
      Object.keys(cards).forEach(function (key) {
        cards[key].classList.toggle('is-active', key === id);
      });
      var card = cards[id];
      if (card && listEl) {
        var top = card.offsetTop - listEl.offsetTop - 12;
        listEl.parentNode.scrollTo({ top: top, behavior: 'smooth' });
      }
      var marker = markers[id];
      if (marker && pan && map) {
        if (cluster && cluster.zoomToShowLayer) {
          cluster.zoomToShowLayer(marker, function () { marker.openPopup(); });
        } else {
          map.setView(marker.getLatLng(), Math.max(map.getZoom(), 12));
          marker.openPopup();
        }
      }
    }

    function syncMarkers() {
      if (!cluster) return;
      cluster.clearLayers();
      var layers = [];
      filtered.forEach(function (store) {
        var marker = markers[store.id];
        if (marker) layers.push(marker);
      });
      cluster.addLayers(layers);
    }

    function initMap() {
      var L = window.L;
      map = L.map(canvas, {
        scrollWheelZoom: false,
        zoomControl: true,
        attributionControl: true
      });
      map.setView(cfg.center || [56.1, -96.8], cfg.zoom || 3);

      L.tileLayer(cfg.tiles, {
        attribution: cfg.attribution || '',
        subdomains: 'abcd',
        maxZoom: 19
      }).addTo(map);

      // La molette zoome seulement apres un clic dans la carte :
      // sinon on se fait pieger en scrollant la page.
      map.on('click focus', function () { map.scrollWheelZoom.enable(); });
      map.on('mouseout', function () { map.scrollWheelZoom.disable(); });

      cluster = L.markerClusterGroup({
        showCoverageOnHover: false,
        maxClusterRadius: 46,
        iconCreateFunction: function (c) {
          var n = c.getChildCount();
          var size = n < 10 ? 34 : (n < 100 ? 42 : 50);
          return L.divIcon({
            className: 'lp-cluster',
            html: '<span>' + n + '</span>',
            iconSize: [size, size]
          });
        }
      });

      stores.forEach(function (store) {
        if (store.lat == null) return;
        var marker = L.marker([store.lat, store.lng], { icon: pinIcon(store) });
        marker.bindPopup(popupHtml(store));
        marker.on('click', function () { highlight(store.id, false); });
        markers[store.id] = marker;
      });

      map.addLayer(cluster);
      map.on('moveend', function () {
        if (boundsOnly) apply();
      });

      syncMarkers();
      fitAll();
    }

    function fitAll() {
      if (!map) return;
      var pts = filtered.filter(function (s) { return s.lat != null; })
                        .map(function (s) { return [s.lat, s.lng]; });
      if (!pts.length) return;
      map.fitBounds(pts, { padding: [40, 40], maxZoom: 12 });
    }

    /* ------------------------------------------------ geoloc */

    function locate() {
      if (!navigator.geolocation) {
        say(cfg.geoUnsupported || 'La geolocalisation n\'est pas disponible.');
        return;
      }
      say(cfg.geoSearching || 'Recherche de votre position\u2026');
      nearBtn.classList.add('is-busy');

      navigator.geolocation.getCurrentPosition(function (pos) {
        nearBtn.classList.remove('is-busy');
        origin = { lat: pos.coords.latitude, lng: pos.coords.longitude };

        stores.forEach(function (store) {
          store._d = store.lat == null
            ? null
            : lpDistance(origin.lat, origin.lng, store.lat, store.lng);
        });

        activeProv = '';
        if (input) input.value = '';
        if (chipWrap) {
          chipWrap.querySelectorAll('[data-lp-map-prov]').forEach(function (b) {
            b.classList.toggle('is-active', b.getAttribute('data-lp-map-prov') === '');
          });
        }
        boundsOnly = false;
        if (areaToggle) areaToggle.checked = false;

        apply();
        say(cfg.geoDone || 'Les points de vente les plus proches de vous.');

        if (map) {
          var near = filtered.slice(0, 5)
                             .filter(function (s) { return s.lat != null; })
                             .map(function (s) { return [s.lat, s.lng]; });
          near.push([origin.lat, origin.lng]);
          if (near.length > 1) map.fitBounds(near, { padding: [50, 50] });
        }
      }, function () {
        nearBtn.classList.remove('is-busy');
        say(cfg.geoDenied || 'Position refusee. Cherchez par ville ou code postal.');
      }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
    }

    /* ------------------------------------------------ demarrage */

    function buildChips(data) {
      if (!chipWrap) return;
      var names = cfg.provinceNames || {};
      var counts = {};
      stores.forEach(function (s) { counts[s.prov] = (counts[s.prov] || 0) + 1; });

      var all = document.createElement('button');
      all.type = 'button';
      all.className = 'lp-map__chip is-active';
      all.setAttribute('data-lp-map-prov', '');
      all.textContent = (cfg.allLabel || 'Toutes') + ' \u00b7 ' + stores.length;
      chipWrap.appendChild(all);

      (data.provinces || []).forEach(function (prov) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lp-map__chip';
        b.setAttribute('data-lp-map-prov', prov);
        b.textContent = (names[prov] || prov) + ' \u00b7 ' + (counts[prov] || 0);
        chipWrap.appendChild(b);
      });
    }

    function start(data) {
      stores = (data.stores || []).map(function (store) {
        store._hay = lpNorm([
          store.name, store.city, store.prov, store.address,
          store.postal, (store.postal || '').slice(0, 3), store.chain
        ].join(' '));
        return store;
      });

      if (statTotal) statTotal.textContent = data.count || stores.length;
      if (statProv) statProv.textContent = (data.provinces || []).length;
      if (statCity) statCity.textContent = data.cities || '';

      buildChips(data);
      filtered = stores.slice();
      renderList();

      lpLoadCss(root.getAttribute('data-lp-map-css'));
      lpLoadCss(root.getAttribute('data-lp-map-cluster-css'));

      lpLoadJs(root.getAttribute('data-lp-map-js'))
        .then(function () { return lpLoadJs(root.getAttribute('data-lp-map-cluster-js')); })
        .then(function () {
          if (!window.L || !canvas) return;
          initMap();
          root.classList.add('is-mapped');
        })
        .catch(function () {
          // La liste reste utilisable sans la carte.
          root.classList.add('is-map-failed');
        });
    }

    /* ------------------------------------------------ ecouteurs */

    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(input._t);
        input._t = setTimeout(apply, 160);
      });
    }

    if (chipWrap) {
      chipWrap.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-lp-map-prov]');
        if (!chip) return;
        activeProv = chip.getAttribute('data-lp-map-prov');
        chipWrap.querySelectorAll('[data-lp-map-prov]').forEach(function (b) {
          b.classList.remove('is-active');
        });
        chip.classList.add('is-active');
        apply();
        fitAll();
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', renderChunk);
    }

    if (nearBtn) {
      nearBtn.addEventListener('click', locate);
    }

    if (areaToggle) {
      areaToggle.addEventListener('change', function () {
        boundsOnly = areaToggle.checked;
        apply();
      });
    }

    if (listEl) {
      listEl.addEventListener('click', function (e) {
        var card = e.target.closest('[data-lp-map-card]');
        if (!card || e.target.closest('a')) return;
        highlight(card.getAttribute('data-lp-map-card'), true);
      });
      listEl.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        var card = e.target.closest('[data-lp-map-card]');
        if (card) highlight(card.getAttribute('data-lp-map-card'), true);
      });
    }

    /* ------------------------------------------------ donnees */

    /* La section peut porter sa propre adresse de flux ; sinon celle
       des parametres du theme, sinon le fichier genere. */
    if (root.getAttribute('data-lp-map-feed') && !window.LP_STORES_FEED) {
      window.LP_STORES_FEED = root.getAttribute('data-lp-map-feed');
    }

    lpLoadStores(root.getAttribute('data-lp-map-src'))
      .then(function (data) { start(lpStoresData(data)); })
      .catch(function () {
        root.classList.add('is-data-failed');
        say(cfg.dataFailed || 'La liste des points de vente n\'a pas pu etre chargee.');
      });
  }

  /* ----------------------------------------------------------
     14. CONSTRUCTEUR DE STACK — version complete
     Une etape par moment de la journee, un produit par etape,
     une saveur par produit. Objectifs de depart qui remplissent
     tout d'un coup, recapitulatif en direct, partage par URL.

     Toutes les donnees de prix vivent dans le DOM, sur les
     pastilles de saveur : rien n'est duplique en JSON, donc
     rien ne peut se desynchroniser du rendu Liquid.
     ---------------------------------------------------------- */
  function bindStack() {
    var root = document.querySelector('[data-lp-stack]');
    if (!root || root.dataset.lpBound === 'on') return;
    root.dataset.lpBound = 'on';

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-lp-stack-step]'));
    var summaryEl = root.querySelector('[data-lp-stack-summary]');
    var totalEl = root.querySelector('[data-lp-stack-total]');
    var saveEl = root.querySelector('[data-lp-stack-save]');
    var addBtn = root.querySelector('[data-lp-stack-add]');
    var shareBtn = root.querySelector('[data-lp-stack-share]');
    var countEl = root.querySelector('[data-lp-stack-count]');
    var statusEl = root.querySelector('[data-lp-stack-status]');

    var moneyFormat = root.getAttribute('data-lp-money') || '${{amount}}';
    var labels = {
      empty: root.getAttribute('data-lp-label-empty') || '',
      pick: root.getAttribute('data-lp-label-pick') || 'Choose a flavour',
      added: root.getAttribute('data-lp-label-added') || 'Added',
      copied: root.getAttribute('data-lp-label-copied') || 'Link copied',
      error: root.getAttribute('data-lp-label-error') || 'Something went wrong. Try again.'
    };

    /* ------------------------------------------------ argent */

    function money(cents) {
      var parts = (cents / 100).toFixed(2).split('.');
      // Les formats « comma_separator » sont a l'europeenne :
      // point pour les milliers, virgule pour les decimales.
      var grouped = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var dotted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, dotted)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dotted + ',' + parts[1])
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, grouped)
        .replace(/\{\{\s*amount\s*\}\}/, grouped + '.' + parts[1]);
    }

    /* ------------------------------------------- etat courant */

    function chosenVariant(step) {
      return step.querySelector('[data-lp-stack-variant].is-chosen');
    }

    function chosenProduct(step) {
      return step.querySelector('[data-lp-stack-pick].is-chosen');
    }

    function readSelection() {
      return steps.map(function (step) {
        var variant = chosenVariant(step);
        var product = chosenProduct(step);
        if (!variant || !product) return null;
        return {
          step: step,
          stepTitle: step.getAttribute('data-lp-stack-step-title') || '',
          id: variant.getAttribute('data-lp-stack-variant'),
          flavour: variant.getAttribute('data-lp-flavour') || '',
          colour: variant.getAttribute('data-lp-colour') || '',
          name: product.getAttribute('data-lp-name') || '',
          price: parseInt(variant.getAttribute('data-price'), 10) || 0,
          compare: parseInt(variant.getAttribute('data-compare'), 10) || 0
        };
      }).filter(Boolean);
    }

    /* ---------------------------------------------- affichage */

    function renderSummary() {
      var picks = readSelection();
      var total = 0;
      var saved = 0;

      picks.forEach(function (pick) {
        total += pick.price;
        if (pick.compare > pick.price) saved += pick.compare - pick.price;
      });

      if (summaryEl) {
        summaryEl.innerHTML = '';
        if (!picks.length && labels.empty) {
          var empty = document.createElement('li');
          empty.className = 'lp-stack__summary-empty';
          empty.textContent = labels.empty;
          summaryEl.appendChild(empty);
        }
        picks.forEach(function (pick) {
          var li = document.createElement('li');
          li.className = 'lp-stack__summary-row';
          li.innerHTML =
            '<span class="lp-stack__summary-dot"></span>' +
            '<span class="lp-stack__summary-text">' +
              '<strong></strong><em></em>' +
            '</span>' +
            '<span class="lp-stack__summary-price"></span>';
          li.querySelector('.lp-stack__summary-dot').style.background = pick.colour || '#9AA0A6';
          li.querySelector('strong').textContent = pick.name;
          li.querySelector('em').textContent = pick.flavour;
          li.querySelector('.lp-stack__summary-price').textContent = money(pick.price);
          summaryEl.appendChild(li);
        });
      }

      if (totalEl) totalEl.textContent = picks.length ? money(total) : '\u2014';
      if (saveEl) {
        saveEl.textContent = saved > 0 ? money(saved) : '';
        saveEl.hidden = saved <= 0;
      }
      if (countEl) countEl.textContent = picks.length;
      if (addBtn) addBtn.disabled = picks.length === 0;

      root.classList.toggle('is-complete', picks.length === steps.length && steps.length > 0);
      return picks;
    }

    /* ------------------------------------------- interactions */

    function clearStep(step) {
      step.querySelectorAll('.is-chosen').forEach(function (node) {
        node.classList.remove('is-chosen');
      });
      step.querySelectorAll('[data-lp-stack-flavours]').forEach(function (node) {
        node.hidden = true;
      });
      step.querySelectorAll('[data-lp-stack-facts]').forEach(function (node) {
        node.hidden = true;
      });
    }

    function pickProduct(step, button, autoFlavour) {
      var wasChosen = button.classList.contains('is-chosen');
      clearStep(step);
      if (wasChosen) {
        renderSummary();
        return;
      }

      button.classList.add('is-chosen');

      var option = button.closest('[data-lp-stack-option]');
      if (option) {
        var flavours = option.querySelector('[data-lp-stack-flavours]');
        var facts = option.querySelector('[data-lp-stack-facts]');
        if (flavours) flavours.hidden = false;
        if (facts) facts.hidden = false;

        // Une seule saveur disponible : inutile de faire cliquer.
        var available = flavours
          ? flavours.querySelectorAll('[data-lp-stack-variant]:not([disabled])')
          : [];
        if (autoFlavour !== false && available.length === 1) {
          available[0].classList.add('is-chosen');
        }
      }
      renderSummary();
    }

    root.addEventListener('click', function (event) {
      var pick = event.target.closest('[data-lp-stack-pick]');
      if (pick) {
        pickProduct(pick.closest('[data-lp-stack-step]'), pick, true);
        return;
      }

      var variant = event.target.closest('[data-lp-stack-variant]');
      if (variant && !variant.disabled) {
        var host = variant.closest('[data-lp-stack-flavours]');
        host.querySelectorAll('[data-lp-stack-variant]').forEach(function (node) {
          node.classList.remove('is-chosen');
        });
        variant.classList.add('is-chosen');
        renderSummary();
        return;
      }

      var goal = event.target.closest('[data-lp-stack-goal]');
      if (goal) {
        applyGoal(goal);
      }
    });

    /* ---------------------------------------------- objectifs */

    function applyGoal(goal) {
      root.querySelectorAll('[data-lp-stack-goal]').forEach(function (node) {
        node.classList.toggle('is-chosen', node === goal);
      });

      var wanted = (goal.getAttribute('data-lp-stack-picks') || '')
        .split(',')
        .map(function (value) { return value.trim(); })
        .filter(Boolean);

      steps.forEach(function (step) {
        clearStep(step);
        for (var i = 0; i < wanted.length; i++) {
          var button = step.querySelector('[data-lp-stack-pick][data-lp-product="' + wanted[i] + '"]');
          if (button) {
            pickProduct(step, button, true);
            break;
          }
        }
      });

      renderSummary();

      var timeline = root.querySelector('[data-lp-stack-timeline]');
      if (timeline) timeline.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* ------------------------------------------------ partage */

    function stackParam() {
      return readSelection().map(function (pick) { return pick.id; }).join(',');
    }

    function restoreFromUrl() {
      var match = /[?&]stack=([^&]+)/.exec(window.location.search);
      if (!match) return;
      var ids = decodeURIComponent(match[1]).split(',').filter(Boolean);

      ids.forEach(function (id) {
        var variant = root.querySelector('[data-lp-stack-variant="' + id + '"]');
        if (!variant) return;
        var option = variant.closest('[data-lp-stack-option]');
        var step = variant.closest('[data-lp-stack-step]');
        var button = option ? option.querySelector('[data-lp-stack-pick]') : null;
        if (!step || !button) return;
        pickProduct(step, button, false);
        variant.classList.add('is-chosen');
      });

      renderSummary();
    }

    function say(message) {
      if (!statusEl) return;
      statusEl.textContent = message || '';
      clearTimeout(statusEl._t);
      statusEl._t = setTimeout(function () { statusEl.textContent = ''; }, 3200);
    }

    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var url = window.location.origin + window.location.pathname + '?stack=' + stackParam();
        var done = function () { say(labels.copied); };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, function () { window.prompt('', url); });
        } else {
          window.prompt('', url);
        }
      });
    }

    /* -------------------------------------------- ajout panier */

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var picks = readSelection();
        if (!picks.length) return;

        addBtn.classList.add('is-busy');
        addBtn.disabled = true;
        document.dispatchEvent(new CustomEvent('dynamic-cart-loading'));

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: picks.map(function (pick) {
              return { id: Number(pick.id), quantity: 1 };
            }),
            sections: 'cart-main,header,announcement-bar'
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('cart');
            return response.json();
          })
          .then(function (data) {
            addBtn.classList.remove('is-busy');
            addBtn.classList.add('is-done');
            addBtn.disabled = false;
            setTimeout(function () { addBtn.classList.remove('is-done'); }, 2200);

            document.dispatchEvent(new CustomEvent('ajax-cart', {
              detail: { cartSections: data.sections }
            }));
            document.dispatchEvent(new CustomEvent('dynamic-cart-open'));
          })
          .catch(function () {
            addBtn.classList.remove('is-busy');
            addBtn.disabled = false;
            say(labels.error);
          });
      });
    }

    /* -------------------------------------------------- depart */

    var preset = root.querySelector('[data-lp-stack-goal][data-lp-default="on"]');
    if (preset) {
      applyGoal(preset);
    } else {
      renderSummary();
    }
    restoreFromUrl();
  }

  /* ----------------------------------------------------------
     15. FORMULAIRE DE CONTACT
     Le champ « numero de commande » s'affiche par :has() en CSS.
     Cette fonction ne fait que poser une classe equivalente, en
     repli pour un navigateur sans :has(). Si :has() marche, la
     classe ne sert a rien et ne gene rien.
     ---------------------------------------------------------- */
  function bindContactForm() {
    var form = document.querySelector('.lp-contact__form');
    if (!form || form.dataset.lpBound === 'on') return;
    form.dataset.lpBound = 'on';

    if (!form.querySelector('.lp-contact__field--order')) return;

    function sync() {
      form.classList.toggle('is-order', !!form.querySelector('[data-lp-order]:checked'));
    }

    form.addEventListener('change', function (event) {
      if (event.target.name === 'contact[subject]') sync();
    });

    sync();
  }

  /* ----------------------------------------------------------
     16. PARALLAXE DU MOT-SYMBOLE
     Le LIMITLESS geant du footer se revele en montant pendant
     le defilement — quelques dizaines de pixels, pas plus.
     rAF + lecture unique par frame ; inactif si l'utilisateur
     prefere reduire les animations.
     ---------------------------------------------------------- */
  function bindParallax() {
    var node = document.querySelector('[data-lp-parallax]');
    if (!node || node.dataset.lpBound === 'on') return;
    node.dataset.lpBound = 'on';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var target = node.firstElementChild || node;
    var ticking = false;

    function frame() {
      ticking = false;
      var rect = node.getBoundingClientRect();
      var viewport = window.innerHeight || 1;
      if (rect.top > viewport || rect.bottom < 0) return;
      // 0 quand le haut du bloc touche le bas de l'ecran,
      // 1 quand son bas est visible en entier.
      var progress = Math.min(1, Math.max(0, (viewport - rect.top) / (rect.height + viewport)));
      var shift = (1 - progress) * 60;              // px, part de +60 et revient a 0
      target.style.transform = 'translate3d(0, ' + shift.toFixed(1) + 'px, 0)';
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(frame);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    frame();
  }

  /* ----------------------------------------------------------
     17. ROTATION DE LA BARRE D'ANNONCE
     Mode « une pilule » : les messages se relaient en fondu.
     La pilule active est en position relative, les autres en
     absolu par-dessus : la hauteur suit toujours le message
     visible. Pause au survol et au focus ; pas de rotation si
     l'utilisateur prefere reduire les animations.
     ---------------------------------------------------------- */
  function bindAnnounceRotate() {
    var host = document.querySelector('[data-lp-announce-rotate]');
    if (!host || host.dataset.lpRotBound === 'on') return;
    host.dataset.lpRotBound = 'on';

    var pills = Array.prototype.slice.call(host.querySelectorAll('.lp-announce__pill'));
    if (!pills.length) return;

    var index = 0;
    pills[0].classList.add('is-live');
    if (pills.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var speed = (parseInt(host.getAttribute('data-lp-announce-speed'), 10) || 6) * 1000;
    var paused = false;

    setInterval(function () {
      if (paused || document.hidden) return;
      pills[index].classList.remove('is-live');
      index = (index + 1) % pills.length;
      pills[index].classList.add('is-live');
    }, speed);

    host.addEventListener('mouseenter', function () { paused = true; });
    host.addEventListener('mouseleave', function () { paused = false; });
    host.addEventListener('focusin', function () { paused = true; });
    host.addEventListener('focusout', function () { paused = false; });
  }

  /* ----------------------------------------------------------
     18. COMPTE A REBOURS
     [data-lp-countdown="AAAA-MM-JJ(THH:MM)"] : remplit jours,
     heures, minutes, secondes. Date passee ou illisible : le
     bloc reste masque, la page ne bouge pas. Tick une fois par
     seconde, coupe quand l'onglet est cache.
     Plusieurs instances possibles sur une meme page (le heros
     et la carte du deal partagent la meme echeance).
     ---------------------------------------------------------- */
  function bindCountdown() {
    var nodes = document.querySelectorAll('[data-lp-countdown]');
    if (!nodes.length) return;

    nodes.forEach(function (node) {
      if (node.dataset.lpBound === 'on') return;
      node.dataset.lpBound = 'on';

      var raw = node.getAttribute('data-lp-countdown') || '';
      var end = new Date(raw.length <= 10 ? raw + 'T23:59:59' : raw).getTime();
      if (isNaN(end)) return;

      var days = node.querySelector('[data-lp-count-days]');
      var hours = node.querySelector('[data-lp-count-hours]');
      var mins = node.querySelector('[data-lp-count-mins]');
      var secs = node.querySelector('[data-lp-count-secs]');

      function pad(value) { return value < 10 ? '0' + value : String(value); }

      function tick() {
        var left = end - Date.now();
        if (left <= 0) {
          node.hidden = true;
          clearInterval(timer);
          return;
        }
        node.hidden = false;
        var s = Math.floor(left / 1000);
        if (days) days.textContent = Math.floor(s / 86400);
        if (hours) hours.textContent = pad(Math.floor(s / 3600) % 24);
        if (mins) mins.textContent = pad(Math.floor(s / 60) % 60);
        if (secs) secs.textContent = pad(s % 60);
      }

      var timer = setInterval(function () {
        if (!document.hidden) tick();
      }, 1000);
      tick();
    });
  }

  /* ----------------------------------------------------------
     19. COPIE EN UN CLIC
     Tout [data-lp-copy] copie sa valeur et confirme brievement.
     Repli par selection si l'API presse-papiers est refusee
     (contexte non securise, permission bloquee).
     ---------------------------------------------------------- */
  function bindCopy() {
    document.querySelectorAll('[data-lp-copy]').forEach(function (btn) {
      if (btn.dataset.lpBound === 'on') return;
      btn.dataset.lpBound = 'on';

      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-lp-copy') || '';
        var done = function () {
          btn.classList.add('is-copied');
          setTimeout(function () { btn.classList.remove('is-copied'); }, 2000);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(value).then(done, function () { window.prompt('', value); });
        } else {
          window.prompt('', value);
        }
      });
    });
  }

  /* ----------------------------------------------------------
     20. AJOUT DU DEAL COMPLET
     [data-lp-deal-add="variantId:qty,variantId:qty"] ajoute
     toute la combinaison d'un coup. Si un code est fourni, on
     propose ensuite d'aller au paiement avec le code deja
     applique (Shopify n'applique un code qu'au checkout).
     ---------------------------------------------------------- */
  function bindDealAdd() {
    document.querySelectorAll('[data-lp-deal-add]').forEach(function (btn) {
      if (btn.dataset.lpBound === 'on') return;
      btn.dataset.lpBound = 'on';

      var items = (btn.getAttribute('data-lp-deal-add') || '')
        .split(',')
        .map(function (pair) {
          var bits = pair.split(':');
          return { id: Number(bits[0]), quantity: Number(bits[1]) || 1 };
        })
        .filter(function (i) { return i.id; });

      if (!items.length) {
        btn.disabled = true;
        return;
      }

      btn.addEventListener('click', function () {
        btn.classList.add('is-busy');
        btn.disabled = true;
        document.dispatchEvent(new CustomEvent('dynamic-cart-loading'));

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items, sections: 'header' })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart');
            return r.json();
          })
          .then(function (data) {
            btn.classList.remove('is-busy');
            btn.classList.add('is-done');
            btn.disabled = false;

            var label = btn.getAttribute('data-lp-deal-done');
            if (label) {
              if (!btn.dataset.lpLabel) btn.dataset.lpLabel = btn.textContent.trim();
              btn.textContent = label;
              setTimeout(function () {
                btn.textContent = btn.dataset.lpLabel;
                btn.classList.remove('is-done');
              }, 2200);
            }

            document.dispatchEvent(new CustomEvent('ajax-cart', {
              detail: { cartSections: data.sections }
            }));
            document.dispatchEvent(new CustomEvent('dynamic-cart-open'));
          })
          .catch(function () {
            btn.classList.remove('is-busy');
            btn.disabled = false;
          });
      });
    });
  }

  /* ----------------------------------------------------------
     21. LISTE REELLE DES POINTS DE VENTE (accueil)
     La section d'accueil est batie sur des blocs saisis a la
     main. En mode « liste reelle », on remplace les cartes et
     les filtres par les vraies donnees de lp-stores.json, en
     reutilisant exactement le meme markup : le CSS ne bouge pas.

     Le script inline de la section a deja capture les anciens
     noeuds ; on clone le champ et les filtres pour couper ses
     ecouteurs, puis on rebranche les notres.
     ---------------------------------------------------------- */
  function bindStoreList() {
    var root = document.querySelector('[data-lp-stores-live][data-lp-store-live-list]');
    if (!root || root.dataset.lpListBound === 'on') return;
    root.dataset.lpListBound = 'on';

    var list = root.querySelector('.lp-stores__list');
    var counter = root.querySelector('[data-lp-store-count]');
    var empty = root.querySelector('[data-lp-store-empty]');
    var regionsWrap = root.querySelector('.lp-stores__regions');
    var input = root.querySelector('.lp-stores__input');
    if (!list) return;

    var limit = parseInt(root.getAttribute('data-lp-store-limit'), 10) || 6;
    var labels = {
      one: root.getAttribute('data-lp-label-one') || 'location',
      many: root.getAttribute('data-lp-label-many') || 'locations',
      all: root.getAttribute('data-lp-label-all') || 'All',
      directions: root.getAttribute('data-lp-label-directions') || 'Directions',
      website: root.getAttribute('data-lp-label-website') || 'Website'
    };

    var all = [];
    var region = '';

    // Le JSON stocke des codes ; les filtres affichent des noms.
    var PROV = {
      QC: 'Québec', ON: 'Ontario', BC: 'Colombie-Britannique',
      AB: 'Alberta', MB: 'Manitoba', SK: 'Saskatchewan',
      NB: 'Nouveau-Brunswick', NS: 'Nouvelle-Écosse',
      NL: 'Terre-Neuve', PE: 'Île-du-Prince-Édouard',
      YT: 'Yukon', NT: 'T.N.-O.', NU: 'Nunavut'
    };

    function norm(v) {
      return (v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    function card(store, i) {
      var li = document.createElement('li');
      li.className = 'lp-stores__item';
      li.setAttribute('data-lp-store', '');

      var addr = [store.address, store.city, store.prov].filter(Boolean).join(', ');
      var maps = 'https://www.google.com/maps/dir/?api=1&destination=' +
                 encodeURIComponent(addr + (store.postal ? ' ' + store.postal : ''));
      var idx = String(i + 1).padStart(2, '0');

      var head = '<div class="lp-stores__item-head">' +
        '<span class="lp-stores__index">' + idx + '</span>' +
        (store.prov ? '<span class="lp-stores__tag">' + (PROV[store.prov] || store.prov) + '</span>' : '') +
        '</div>';

      var main = '<div class="lp-stores__item-main">' +
        '<h3 class="lp-stores__name"></h3>' +
        '<address class="lp-stores__address"><span></span></address>' +
        '</div>';

      var actions = '<div class="lp-stores__item-actions">' +
        (store.phone ? '<a class="lp-stores__link" href="tel:' +
          String(store.phone).replace(/[^\d+]/g, '') + '"></a>' : '') +
        (store.website ? '<a class="lp-stores__link" target="_blank" rel="noopener" href="' +
          store.website + '">' + labels.website + '</a>' : '') +
        '<a class="lp-stores__directions" target="_blank" rel="noopener" href="' + maps + '">' +
          labels.directions +
        '</a></div>';

      li.innerHTML = head + main + actions;
      li.querySelector('.lp-stores__name').textContent = store.name || '';
      li.querySelector('.lp-stores__address span').textContent =
        [store.address, [store.city, store.prov].filter(Boolean).join(', ')]
          .filter(Boolean).join(' — ') + (store.postal ? ' ' + store.postal : '');
      var tel = li.querySelector('a[href^="tel:"]');
      if (tel) tel.textContent = store.phone;
      return li;
    }

    function render() {
      var term = norm(input ? input.value : '').trim();
      var matches = all.filter(function (s) {
        var hay = norm([s.name, s.address, s.city, s.prov, PROV[s.prov], s.postal, s.chain]
                      .filter(Boolean).join(' '));
        var okTerm = term === '' || hay.indexOf(term) !== -1;
        var okRegion = region === '' || norm(s.prov) === region;
        return okTerm && okRegion;
      });

      list.innerHTML = '';
      matches.slice(0, limit).forEach(function (s, i) { list.appendChild(card(s, i)); });

      if (counter) {
        counter.textContent = matches.length + ' ' +
          (matches.length === 1 ? labels.one : labels.many);
      }
      if (empty) empty.hidden = matches.length !== 0;
    }

    function buildRegions(provinces) {
      if (!regionsWrap) return;
      regionsWrap.innerHTML = '';

      var mk = function (label, value, active) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lp-stores__region' + (active ? ' is-active' : '');
        b.textContent = label;
        b.addEventListener('click', function () {
          region = norm(value);
          regionsWrap.querySelectorAll('.lp-stores__region').forEach(function (x) {
            x.classList.remove('is-active');
          });
          b.classList.add('is-active');
          render();
        });
        return b;
      };

      regionsWrap.appendChild(mk(labels.all, '', true));
      provinces.forEach(function (p) {
        regionsWrap.appendChild(mk(PROV[p] || p, p, false));
      });
    }

    function start(data) {
      all = data.stores || data.items || [];
      if (!all.length) return;

      // Couper les ecouteurs du script inline de la section.
      if (input) {
        var fresh = input.cloneNode(true);
        input.parentNode.replaceChild(fresh, input);
        input = fresh;
        input.addEventListener('input', render);
      }

      buildRegions(data.provinces || []);
      render();
    }

    lpLoadStores(root.getAttribute('data-lp-stores-src'))
      .then(function (data) { start(lpStoresData(data)); })
      .catch(function () {});
  }

  /* ----------------------------------------------------------
     22. LE PANIER EN SEMAINES D'ENTRAINEMENT
     Un montant ne parle a personne ; « trois mois d'entrainement »
     si. On additionne les portions du panier (table exposee par
     snippets/lp-servings-data, alimentee par le metachamp
     lp.servings) et on traduit en duree.

     Sans metachamp sur aucun produit, la table est vide et rien
     ne s'affiche : on n'annonce jamais un chiffre invente.
     ---------------------------------------------------------- */
  function bindTrainingDays() {
    var data = document.getElementById('lp-servings-data');
    if (!data) return;

    var table;
    try { table = JSON.parse(data.textContent); } catch (e) { return; }
    if (!table || !Object.keys(table).length) return;

    // Frequence d'entrainement de reference. 5 seances par
    // semaine correspond au profil dominant en supplement.
    var perWeek = parseInt(data.getAttribute('data-per-week'), 10) || 5;

    function duration(servings) {
      var weeks = servings / perWeek;
      if (weeks >= 8) return Math.round(weeks / 4.345) + ' months of training';
      if (weeks >= 2) return Math.round(weeks) + ' weeks of training';
      var sessions = Math.round(servings);
      return sessions + (sessions === 1 ? ' session' : ' sessions');
    }

    function paint(cart) {
      var servings = 0;
      (cart.items || []).forEach(function (item) {
        var s = table[String(item.variant_id)];
        if (s) servings += s * item.quantity;
      });

      document.querySelectorAll('.cart__body-footer').forEach(function (host) {
        var node = host.querySelector('.lp-training');

        if (!servings) {
          if (node) node.remove();
          return;
        }
        if (!node) {
          node = document.createElement('p');
          node.className = 'lp-training';
          node.innerHTML = '<b></b><span></span>';
          host.insertBefore(node, host.firstChild);
        }
        node.querySelector('b').textContent = duration(servings);
        node.querySelector('span').textContent = label('servings', servings);
      });
    }

    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(paint)
        .catch(function () {});
    }

    document.addEventListener('ajax-cart', refresh);
    refresh();
  }

  /* ----------------------------------------------------------
     23. QUIZ DE SAVEUR
     Trois questions, un classement, un ajout. Le score se
     calcule sur le NOM des variantes contre des dictionnaires
     de mots-cles : aucune donnee a saisir, un nouveau parfum
     est classe des sa creation.
     ---------------------------------------------------------- */
  function bindQuiz() {
    var root = document.querySelector('[data-lp-quiz]');
    if (!root || root.dataset.lpBound === 'on') return;
    root.dataset.lpBound = 'on';

    var store = root.querySelector('[data-lp-quiz-data]');
    if (!store) return;

    var variants;
    try { variants = JSON.parse(store.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var W = {};
    ['dessert', 'fruity', 'neutral', 'creamy', 'protein', 'energy'].forEach(function (k) {
      W[k] = (store.getAttribute('data-words-' + k) || '')
        .split(',')
        .map(function (w) { return w.trim().toLowerCase(); })
        .filter(Boolean);
    });

    var L = {
      add: store.getAttribute('data-label-add') || 'Add to cart',
      added: store.getAttribute('data-label-added') || 'Added',
      view: store.getAttribute('data-label-view') || 'See the product',
      empty: store.getAttribute('data-label-empty') || ''
    };

    var steps = root.querySelectorAll('[data-lp-quiz-step]');
    var result = root.querySelector('[data-lp-quiz-result]');
    var cards = root.querySelector('[data-lp-quiz-cards]');
    var progress = root.querySelector('[data-lp-quiz-progress]');
    var stepsWrap = root.querySelector('[data-lp-quiz-steps]');
    var answers = {};
    var at = 1;

    function hits(text, words) {
      var n = (text || '').toLowerCase();
      var c = 0;
      words.forEach(function (w) { if (n.indexOf(w) !== -1) c++; });
      return c;
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function score(v) {
      var name = v.flavour || '';
      var prod = v.product || '';
      var s = hits(name, W[answers.family] || []) * 3;

      // Le lait porte les saveurs cremeuses ; l'eau les allege.
      if (answers.mix === 'milk') s += hits(name, W.creamy);
      else s -= hits(name, W.creamy) * 0.5;

      // Type de produit recherche.
      if (answers.goal === 'protein') s += hits(prod, W.protein) * 2;
      if (answers.goal === 'energy') s += hits(prod, W.energy) * 2;

      return s;
    }

    function show(n) {
      steps.forEach(function (f) {
        f.classList.toggle('is-live', f.getAttribute('data-lp-quiz-step') === String(n));
      });
      if (progress) progress.textContent = Math.min(n, steps.length);
    }

    function finish() {
      var ranked = variants
        .map(function (v) { return { v: v, s: score(v) }; })
        .filter(function (x) { return x.s > 0; })
        .sort(function (a, b) { return b.s - a.s; })
        .slice(0, 3);

      cards.innerHTML = '';

      if (!ranked.length) {
        var li = document.createElement('li');
        li.className = 'lp-quiz__empty';
        li.textContent = L.empty;
        cards.appendChild(li);
      }

      ranked.forEach(function (x, i) {
        var v = x.v;
        var li = document.createElement('li');
        li.className = 'lp-quiz__card' + (i === 0 ? ' is-top' : '');
        li.innerHTML =
          '<span class="lp-quiz__card-media">' +
            (v.image ? '<img src="' + v.image + '" alt="" loading="lazy">' : '') +
          '</span>' +
          '<span class="lp-quiz__card-body">' +
            '<strong class="lp-quiz__card-flavour"></strong>' +
            '<em class="lp-quiz__card-product"></em>' +
            '<span class="lp-quiz__card-price"></span>' +
          '</span>' +
          '<span class="lp-quiz__card-actions">' +
            '<button type="button" class="lp-quiz__add"></button>' +
            '<a class="lp-quiz__view"></a>' +
          '</span>';

        li.querySelector('.lp-quiz__card-flavour').textContent = v.flavour;
        li.querySelector('.lp-quiz__card-product').textContent = v.product;
        li.querySelector('.lp-quiz__card-price').textContent = money(v.price);

        var view = li.querySelector('.lp-quiz__view');
        view.href = v.url;
        view.textContent = L.view;

        var add = li.querySelector('.lp-quiz__add');
        add.textContent = L.add;
        add.addEventListener('click', function () {
          add.disabled = true;
          document.dispatchEvent(new CustomEvent('dynamic-cart-loading'));
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: 'header' })
          })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              add.textContent = L.added;
              add.disabled = false;
              document.dispatchEvent(new CustomEvent('ajax-cart', { detail: { cartSections: data.sections } }));
              document.dispatchEvent(new CustomEvent('dynamic-cart-open'));
            })
            .catch(function () { add.disabled = false; });
        });

        cards.appendChild(li);
      });

      if (stepsWrap) stepsWrap.hidden = true;
      result.hidden = false;
      if (progress) progress.parentNode.hidden = true;
    }

    root.addEventListener('click', function (event) {
      var pick = event.target.closest('[data-lp-quiz-pick]');
      if (pick) {
        answers[pick.getAttribute('data-lp-quiz-pick')] = pick.getAttribute('data-lp-value');
        pick.parentNode.querySelectorAll('button').forEach(function (b) {
          b.classList.remove('is-picked');
        });
        pick.classList.add('is-picked');

        at++;
        if (at > steps.length) finish();
        else show(at);
        return;
      }

      if (event.target.closest('[data-lp-quiz-restart]')) {
        answers = {};
        at = 1;
        result.hidden = true;
        if (stepsWrap) stepsWrap.hidden = false;
        if (progress) progress.parentNode.hidden = false;
        root.querySelectorAll('.is-picked').forEach(function (b) {
          b.classList.remove('is-picked');
        });
        show(1);
      }
    });

    show(1);
  }

  /* ----------------------------------------------------------
     24. DISPONIBLE PRES DE CHEZ VOUS (fiche produit)
     Trouve les detaillants les plus proches, par geolocalisation
     ou par ville / code postal. Reutilise lp-stores.json et le
     cache partage avec la carte et les compteurs.
     ---------------------------------------------------------- */
  function bindNearby() {
    var root = document.querySelector('[data-lp-nearby]');
    if (!root || root.dataset.lpBound === 'on') return;
    root.dataset.lpBound = 'on';

    var list = root.querySelector('[data-lp-nearby-list]');
    var status = root.querySelector('[data-lp-nearby-status]');
    var geoBtn = root.querySelector('[data-lp-nearby-geo]');
    var input = root.querySelector('[data-lp-nearby-input]');

    var limit = parseInt(root.getAttribute('data-lp-limit'), 10) || 3;
    var L = {
      away: root.getAttribute('data-lp-label-away') || 'km away',
      none: root.getAttribute('data-lp-label-none') || '',
      denied: root.getAttribute('data-lp-label-denied') || '',
      searching: root.getAttribute('data-lp-label-searching') || ''
    };

    var PROV = {
      QC: 'QC', ON: 'ON', BC: 'BC', AB: 'AB', MB: 'MB', SK: 'SK',
      NB: 'NB', NS: 'NS', NL: 'NL', PE: 'PE'
    };

    function say(msg) { if (status) status.textContent = msg || ''; }

    function norm(v) {
      return (v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    }

    // Distance a vol d'oiseau, suffisante pour un classement.
    function km(lat1, lon1, lat2, lon2) {
      var R = 6371;
      var dLat = (lat2 - lat1) * Math.PI / 180;
      var dLon = (lon2 - lon1) * Math.PI / 180;
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
              Math.sin(dLon / 2) * Math.sin(dLon / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function paint(rows) {
      list.innerHTML = '';

      if (!rows.length) {
        var none = document.createElement('li');
        none.className = 'lp-nearby__none';
        none.textContent = L.none;
        list.appendChild(none);
        return;
      }

      rows.forEach(function (r) {
        var s = r.store;
        var li = document.createElement('li');
        li.className = 'lp-nearby__item';

        var addr = [s.address, s.city, PROV[s.prov] || s.prov].filter(Boolean).join(', ');
        var maps = 'https://www.google.com/maps/dir/?api=1&destination=' +
                   encodeURIComponent(addr + (s.postal ? ' ' + s.postal : ''));

        li.innerHTML =
          '<span class="lp-nearby__pin" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" fill="none">' +
              '<path d="M12 21s-6.6-5.4-6.6-10.4a6.6 6.6 0 1 1 13.2 0C18.6 15.6 12 21 12 21z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>' +
              '<circle cx="12" cy="10.4" r="2.2" stroke="currentColor" stroke-width="1.7"/>' +
            '</svg>' +
          '</span>' +
          '<span class="lp-nearby__info">' +
            '<strong></strong><em></em>' +
          '</span>' +
          '<span class="lp-nearby__meta">' +
            '<b></b>' +
            '<a target="_blank" rel="noopener"></a>' +
          '</span>';

        li.querySelector('strong').textContent = s.name || '';
        li.querySelector('em').textContent = addr;

        var dist = li.querySelector('b');
        if (r.d != null) dist.textContent = (r.d < 10 ? r.d.toFixed(1) : Math.round(r.d)) + ' ' + L.away;
        else dist.remove();

        var link = li.querySelector('a');
        link.href = maps;
        link.textContent = 'Directions';

        list.appendChild(li);
      });
    }

    function nearest(data, lat, lng) {
      var rows = (data.stores || [])
        .filter(function (s) { return s.lat && s.lng; })
        .map(function (s) { return { store: s, d: km(lat, lng, s.lat, s.lng) }; })
        .sort(function (a, b) { return a.d - b.d; })
        .slice(0, limit);
      paint(rows);
      say('');
    }

    function byText(data, term) {
      var q = norm(term);
      if (!q) { list.innerHTML = ''; return; }

      var rows = (data.stores || [])
        .filter(function (s) {
          return norm(s.city).indexOf(q) === 0 ||
                 norm(s.postal).replace(/\s/g, '').indexOf(q.replace(/\s/g, '')) === 0 ||
                 norm(s.name).indexOf(q) !== -1;
        })
        .slice(0, limit)
        .map(function (s) { return { store: s, d: null }; });

      paint(rows);
    }

    function withData(fn) {
      lpLoadStores(root.getAttribute('data-lp-stores-src'))
        .then(function (data) { fn(lpStoresData(data)); })
        .catch(function () { say(L.denied); });
    }

    if (geoBtn) {
      geoBtn.addEventListener('click', function () {
        if (!navigator.geolocation) { say(L.denied); return; }
        say(L.searching);
        navigator.geolocation.getCurrentPosition(
          function (pos) {
            withData(function (data) {
              nearest(data, pos.coords.latitude, pos.coords.longitude);
            });
          },
          function () { say(L.denied); },
          { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 }
        );
      });
    }

    if (input) {
      var t;
      input.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          withData(function (data) { byText(data, input.value); });
        }, 220);
      });
    }
  }

  /* ----------------------------------------------------------
     25. RAPPEL DE REACHAT
     Pas d'abonnement : l'abandon y est brutal parce que les gens
     detestent s'engager. La consommation, elle, est previsible.
     On calcule la date de fin de stock a partir des portions du
     panier et on l'inscrit sur la commande, avec le
     consentement explicite du client.

     L'envoi se fait ensuite cote Shopify (Flow + Shopify Email),
     pas ici : le theme ne fait qu'enregistrer l'intention et la
     date. Voir les attributs poses sur la commande :
         Reorder reminder        yes
         Runs out in days        68
         Reorder date            2026-11-08
     ---------------------------------------------------------- */
  function bindReorder() {
    var data = document.getElementById('lp-servings-data');
    if (!data) return;

    var table;
    try { table = JSON.parse(data.textContent); } catch (e) { return; }
    if (!table || !Object.keys(table).length) return;

    var perWeek = parseInt(data.getAttribute('data-per-week'), 10) || 5;
    var labels = {
      ask: data.getAttribute('data-reorder-ask') || 'Remind me when I\u2019m running low',
      hint: data.getAttribute('data-reorder-hint') || 'One email, around the day you run out. No subscription.',
      on: data.getAttribute('data-reorder-on') || 'We\u2019ll email you around'
    };

    function daysLeft(cart) {
      var servings = 0;
      (cart.items || []).forEach(function (item) {
        var s = table[String(item.variant_id)];
        if (s) servings += s * item.quantity;
      });
      if (!servings) return 0;
      // Portions consommees a raison de perWeek par semaine.
      return Math.round(servings / perWeek * 7);
    }

    function save(on, days) {
      var when = new Date(Date.now() + days * 86400000);
      var iso = when.toISOString().slice(0, 10);

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Reorder reminder': on ? 'yes' : '',
            'Runs out in days': on ? String(days) : '',
            'Reorder date': on ? iso : ''
          }
        })
      }).catch(function () {});

      return when;
    }

    function paint(cart) {
      var days = daysLeft(cart);

      document.querySelectorAll('.cart__body-footer').forEach(function (host) {
        var box = host.querySelector('.lp-reorder');

        if (!days) {
          if (box) box.remove();
          return;
        }

        if (!box) {
          box = document.createElement('label');
          box.className = 'lp-reorder';
          box.innerHTML =
            '<input type="checkbox">' +
            '<span class="lp-reorder__body">' +
              '<strong></strong><em></em>' +
            '</span>';

          var input = box.querySelector('input');
          var note = box.querySelector('em');

          input.addEventListener('change', function () {
            var when = save(input.checked, days);
            if (input.checked) {
              note.textContent = labels.on + ' ' +
                when.toLocaleDateString(undefined, { month: 'long', day: 'numeric' }) + '.';
            } else {
              note.textContent = labels.hint;
            }
          });

          host.insertBefore(box, host.firstChild);
        }

        box.querySelector('strong').textContent = labels.ask;
        if (!box.querySelector('input').checked) {
          box.querySelector('em').textContent = labels.hint;
        }

        // Le panier a change : la date aussi.
        if (box.querySelector('input').checked) save(true, days);
      });
    }

    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(paint)
        .catch(function () {});
    }

    document.addEventListener('ajax-cart', refresh);
    refresh();
  }

  /* ----------------------------------------------------------
     26. HERO — CARROUSEL DE PROMOTIONS
     Diapo 0 = le hero existant (media + contenu), jamais
     deplace dans le DOM : la video scroll, le sticky et les
     effets de defilement restent intacts. Les diapos promo
     (--k = 1..n) sont superposees. Tout glisse avec la
     propriete CSS `translate`, pilotee par :
       --lp-hero-i     index actif
       --lp-hero-w     largeur de la scene (px)
       --lp-hero-drag  decalage du doigt pendant le swipe (px)
     Swipe tactile, glisser souris, trackpad horizontal,
     fleches, points. Autoplay optionnel (section).
     CSS : lp-reskin.css bloc 84.
     ---------------------------------------------------------- */
  function bindHeroSlider() {
    document.querySelectorAll('[data-lp-hero-slider]').forEach(function (hero) {
      if (hero.dataset.lpSliderBound) return;
      hero.dataset.lpSliderBound = '1';

      var stage = hero.querySelector('[data-lp-hero-stage]');
      var media = hero.querySelector('[data-lp-hero-media]');
      var inner = stage && stage.querySelector('.lp-hero__inner');
      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-lp-hero-slide]'));
      var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-lp-hero-dot]'));
      var prev = hero.querySelector('[data-lp-hero-prev]');
      var next = hero.querySelector('[data-lp-hero-next]');
      if (!stage || !slides.length) return;

      var total = slides.length + 1;
      var index = 0;
      var width = stage.clientWidth;
      var calm = window.matchMedia('(prefers-reduced-motion: reduce)');

      // Les diapos promo sont en absolu : il faut un referentiel.
      // On ne touche pas a une scene deja sticky / relative.
      if (getComputedStyle(stage).position === 'static') {
        stage.style.position = 'relative';
      }

      function measure() {
        width = stage.clientWidth;
        hero.style.setProperty('--lp-hero-w', width + 'px');
        // Les promos commencent sous la bande du menu, comme le media.
        if (media) {
          var top = media.getBoundingClientRect().top - stage.getBoundingClientRect().top;
          hero.style.setProperty('--lp-promo-top', Math.max(0, Math.round(top)) + 'px');
        }
      }

      function go(i) {
        index = (i + total) % total;
        hero.style.setProperty('--lp-hero-i', index);

        if (inner) inner.inert = index !== 0;
        if (media) media.setAttribute('aria-hidden', index !== 0 ? 'true' : 'false');

        slides.forEach(function (slide, n) {
          var on = n + 1 === index;
          slide.inert = !on;
          slide.setAttribute('aria-hidden', on ? 'false' : 'true');
          slide.classList.toggle('is-active', on);
          // Precharge la diapo active et ses voisines.
          if (Math.abs(n + 1 - index) <= 1) {
            var img = slide.querySelector('img[loading="lazy"]');
            if (img) img.loading = 'eager';
          }
        });

        dots.forEach(function (dot, n) {
          var on = n === index;
          dot.classList.toggle('is-active', on);
          if (on) { dot.setAttribute('aria-current', 'true'); } else { dot.removeAttribute('aria-current'); }
        });

        hero.classList.toggle('is-promo', index !== 0);
      }

      /* --- Autoplay ------------------------------------------ */
      var auto = hero.getAttribute('data-autoplay') === 'true';
      var delay = (parseInt(hero.getAttribute('data-interval'), 10) || 6) * 1000;
      var timer = null;
      var paused = false;
      var visible = true;

      function stop() { clearTimeout(timer); timer = null; }
      function arm() {
        stop();
        if (!auto || paused || !visible || calm.matches || document.hidden) return;
        if (window.Shopify && window.Shopify.designMode) return;
        timer = setTimeout(function () { go(index + 1); arm(); }, delay);
      }

      if (auto) {
        hero.addEventListener('pointerenter', function (e) {
          if (e.pointerType === 'mouse') { paused = true; stop(); }
        });
        hero.addEventListener('pointerleave', function (e) {
          if (e.pointerType === 'mouse') { paused = false; arm(); }
        });
        hero.addEventListener('focusin', function () { paused = true; stop(); });
        hero.addEventListener('focusout', function () { paused = false; arm(); });
        document.addEventListener('visibilitychange', arm);
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            visible = entries[0].isIntersecting;
            arm();
          }, { threshold: 0.4 }).observe(stage);
        }
      }

      function user(i) { go(i); arm(); }

      if (prev) prev.addEventListener('click', function () { user(index - 1); });
      if (next) next.addEventListener('click', function () { user(index + 1); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          user(parseInt(dot.getAttribute('data-lp-hero-dot'), 10) || 0);
        });
      });

      /* --- Swipe / glisser ----------------------------------- */
      var startX = 0;
      var startY = 0;
      var startT = 0;
      var dx = 0;
      var axis = null;
      var pointer = null;
      var suppressClick = false;

      function setDrag(px) {
        hero.style.setProperty('--lp-hero-drag', px + 'px');
      }

      stage.addEventListener('pointerdown', function (e) {
        if (e.button !== 0 || pointer !== null) return;
        if (e.target.closest('[data-lp-hero-nav]')) return;
        pointer = e.pointerId;
        startX = e.clientX;
        startY = e.clientY;
        startT = Date.now();
        dx = 0;
        axis = null;
      });

      stage.addEventListener('pointermove', function (e) {
        if (e.pointerId !== pointer) return;
        var mx = e.clientX - startX;
        var my = e.clientY - startY;

        if (!axis) {
          if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
          axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
          if (axis === 'x') {
            hero.classList.add('is-dragging');
            stop();
            try { stage.setPointerCapture(e.pointerId); } catch (err) {}
          }
        }
        if (axis !== 'x') return;

        dx = mx;
        // Resistance aux extremites (pas de boucle au doigt).
        if ((index === 0 && dx > 0) || (index === total - 1 && dx < 0)) dx = dx / 3;
        setDrag(dx);
      });

      function release(e) {
        if (e.pointerId !== pointer) return;
        pointer = null;
        if (axis !== 'x') { axis = null; return; }

        hero.classList.remove('is-dragging');
        suppressClick = Math.abs(dx) > 8;

        var fast = Math.abs(dx) / Math.max(1, Date.now() - startT) > 0.5;
        var far = Math.abs(dx) > width * 0.15;
        var target = index;
        if ((fast || far) && dx < 0 && index < total - 1) target = index + 1;
        if ((fast || far) && dx > 0 && index > 0) target = index - 1;

        setDrag(0);
        axis = null;
        dx = 0;
        user(target);
      }

      stage.addEventListener('pointerup', release);
      stage.addEventListener('pointercancel', release);

      // Un glisser ne doit pas ouvrir le lien de la promo.
      stage.addEventListener('click', function (e) {
        if (!suppressClick) return;
        suppressClick = false;
        e.preventDefault();
        e.stopPropagation();
      }, true);

      stage.addEventListener('dragstart', function (e) { e.preventDefault(); });

      /* --- Trackpad horizontal ------------------------------- */
      var wheelLock = false;
      var wheelSum = 0;
      stage.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        e.preventDefault();
        if (wheelLock) return;
        wheelSum += e.deltaX;
        if (Math.abs(wheelSum) < 40) return;
        var dir = wheelSum > 0 ? 1 : -1;
        wheelSum = 0;
        var target = index + dir;
        if (target < 0 || target > total - 1) return;
        wheelLock = true;
        user(target);
        setTimeout(function () { wheelLock = false; }, 700);
      }, { passive: false });

      /* --- Editeur de theme : suivre le bloc selectionne ---- */
      document.addEventListener('shopify:block:select', function (e) {
        if (!hero.isConnected || !hero.contains(e.target)) return;
        var slide = e.target.closest('[data-lp-hero-slide]');
        go(slide ? slides.indexOf(slide) + 1 : 0);
      });

      if ('ResizeObserver' in window) {
        new ResizeObserver(measure).observe(stage);
      } else {
        window.addEventListener('resize', measure);
      }

      measure();
      go(0);
      arm();
    });
  }

  /* ----------------------------------------------------------
     Lancement + surveillance du contenu differe
     Le theme charge plusieurs sections en lazy : il faut
     rebrancher quand elles arrivent.
     ---------------------------------------------------------- */

  /* ----------------------------------------------------------
     27. LOCALISATEUR — FICHES SAISIES DANS L'EDITEUR DE THEME
     La liste officielle reste assets/lp-stores.json, generee
     depuis l'Excel. Par-dessus, la section « LP — Carte
     magasins » accepte des blocs : un employe ajoute, corrige
     ou retire un detaillant sans toucher au code.

     Regle de rapprochement : nom + ville. Un bloc dont le
     couple existe deja CORRIGE la fiche (rien n'est saisi deux
     fois) ; sinon il en AJOUTE une. Un bloc « Retirer » la
     sort de la liste.

     Rien n'est jamais mutant : on repart du JSON brut a chaque
     appel, sinon l'editeur de theme afficherait la version
     precedente apres chaque modification de bloc.
     ---------------------------------------------------------- */

  var LP_PROV_ORDER = ['QC', 'ON', 'NB', 'NS', 'NL', 'PE', 'MB', 'SK', 'AB', 'BC', 'YT', 'NT', 'NU'];

  /* Meme normalisation que scripts/build-stores.py, pour que
     les cles tombent sur les memes valeurs des deux cotes. */
  function lpSlugKey(value) {
    return (value == null ? '' : String(value))
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/['’ʼ`]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function lpStoreKey(name, city) {
    return lpSlugKey(name) + '|' + lpSlugKey(city);
  }

  /* Coordonnees saisies a la main : on accepte tout ce qu'un
     employe peut raisonnablement coller depuis Google Maps.

       45.5570, -73.8950            clic droit sur le commerce
       45,5570  -73,8950            clavier francais
       (45.5570, -73.8950)
       https://...maps/...@45.5570,-73.8950,17z      URL collee
       45°33'25.2"N 73°53'42.0"O    fiche detaillee

     Renvoie [lat, lng] arrondi, ou null si c'est inexploitable
     — la fiche reste alors dans la liste, sans epingle. */
  function lpParseCoords(raw) {
    var text = (raw == null ? '' : String(raw)).trim();
    if (!text) return null;

    var pair = null;

    if (/^https?:\/\//i.test(text)) {
      var m = text.match(/@(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/) ||
              text.match(/!3d(-?\d+(?:\.\d+)?)!4d(-?\d+(?:\.\d+)?)/) ||
              text.match(/[?&](?:q|ll|daddr|destination|center)=(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)/);
      if (!m) return null;
      pair = [parseFloat(m[1]), parseFloat(m[2])];
    }

    if (!pair && /[NSEWO]/i.test(text) && text.indexOf('°') !== -1) {
      var dms = /(\d+(?:[.,]\d+)?)\s*°\s*(?:(\d+(?:[.,]\d+)?)\s*['′’]\s*)?(?:(\d+(?:[.,]\d+)?)\s*["″”]\s*)?([NSEWO])/gi;
      var parts = [];
      var hit;
      while ((hit = dms.exec(text)) !== null) {
        var num = function (v) { return v ? parseFloat(String(v).replace(',', '.')) : 0; };
        var deg = num(hit[1]) + num(hit[2]) / 60 + num(hit[3]) / 3600;
        var dir = hit[4].toUpperCase();
        if (dir === 'S' || dir === 'W' || dir === 'O') deg = -deg;
        parts.push({ dir: dir, value: deg });
      }
      if (parts.length === 2) {
        var ns = null, ew = null;
        parts.forEach(function (p) {
          if (p.dir === 'N' || p.dir === 'S') { if (!ns) ns = p; }
          else if (!ew) { ew = p; }
        });
        if (ns && ew) pair = [ns.value, ew.value];
      }
    }

    if (!pair) {
      /* La virgule sert de separateur ET de decimale : on lit
         les nombres entiers-virgule-decimales d'un seul coup,
         ce qui marche dans les deux notations. */
      var nums = text.replace(/[()\[\]]/g, ' ').match(/-?\d+(?:[.,]\d+)?/g);
      if (!nums || nums.length < 2) return null;
      pair = [parseFloat(nums[0].replace(',', '.')), parseFloat(nums[1].replace(',', '.'))];
    }

    var lat = pair[0];
    var lng = pair[1];
    if (!isFinite(lat) || !isFinite(lng)) return null;

    /* Inversion latitude/longitude : l'erreur de saisie la plus
       frequente. On ne remet dans l'ordre que lorsque c'est sans
       ambiguite au Canada (latitudes 42 a 83, longitudes -141
       a -52). */
    if (Math.abs(lat) > 90 || (Math.abs(lat) > 60 && Math.abs(lng) < 60)) {
      var swap = lat; lat = lng; lng = swap;
    }
    if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
    if (lat === 0 && lng === 0) return null;

    return [Math.round(lat * 100000) / 100000, Math.round(lng * 100000) / 100000];
  }

  /* Les blocs sont relus a chaque appel : dans l'editeur de
     theme, Shopify re-rend la section a chaque frappe. */
  function lpReadStoreEdits() {
    var node = document.querySelector('[data-lp-map-edits]');
    if (!node) return null;
    try {
      var list = JSON.parse(node.textContent);
      return Array.isArray(list) ? list : null;
    } catch (e) {
      return null;
    }
  }

  function lpApplyStoreEdits(data, edits) {
    var stores = (data.stores || []).slice();
    var index = {};
    stores.forEach(function (s, i) { index[lpStoreKey(s.name, s.city)] = i; });

    var usedIds = {};
    stores.forEach(function (s) { usedIds[s.id] = 1; });

    edits.forEach(function (edit) {
      var name = (edit.name || '').trim();
      var city = (edit.city || '').trim();
      if (!name || !city) return;          // bloc encore vide : on ignore

      var key = lpStoreKey(name, city);
      var at = index[key];
      var old = at === undefined ? null : stores[at];

      if (edit.op === 'hide' || edit.hidden) {
        if (old) { stores[at] = null; delete index[key]; }
        return;
      }

      var coords = lpParseCoords(edit.coords);
      var store = {
        name: name,
        address: (edit.address || '').trim(),
        city: city,
        prov: (edit.prov || '').trim().toUpperCase(),
        postal: (edit.postal || '').trim().toUpperCase()
      };

      /* Correction : ce qui n'est pas saisi dans le bloc est
         repris de la fiche existante, pour qu'un employe puisse
         ne changer qu'une ligne. */
      if (old) {
        store.id = old.id;
        if (!store.address) store.address = old.address;
        if (!store.postal) store.postal = old.postal;
        if (!store.prov) store.prov = old.prov;
        if (old.chain) store.chain = old.chain;
        if (!coords && old.lat != null) {
          store.lat = old.lat;
          store.lng = old.lng;
        }
      } else {
        var base = lpSlugKey(name);
        if (base.indexOf(lpSlugKey(city)) === -1) base = base + '-' + lpSlugKey(city);
        var id = base || 'magasin';
        var n = 2;
        while (usedIds[id]) { id = base + '-' + n; n++; }
        usedIds[id] = 1;
        store.id = id;
      }

      if (coords) { store.lat = coords[0]; store.lng = coords[1]; }
      if (edit.phone) store.phone = String(edit.phone).trim();
      if (edit.website) store.website = String(edit.website).trim();

      if (store.lat == null) {
        store.nogeo = true;
        store._warn = 'Coordonnees manquantes ou illisibles : la fiche est dans la liste, pas sur la carte.';
      } else if (!store.prov) {
        store._warn = 'Province non choisie : la fiche n\'apparait dans aucun filtre.';
      } else if (!store.address) {
        store._warn = 'Adresse vide : l\'itineraire sera approximatif.';
      }

      if (old) {
        stores[at] = store;
      } else {
        index[key] = stores.length;
        stores.push(store);
      }
    });

    stores = stores.filter(Boolean);

    /* Compteurs et pastilles recalcules : sinon la carte
       annoncerait encore le total du fichier Excel. */
    data.stores = stores;
    data.count = stores.length;

    var seenProv = {};
    stores.forEach(function (s) { if (s.prov) seenProv[s.prov] = 1; });
    var provinces = LP_PROV_ORDER.filter(function (p) { return seenProv[p]; });
    Object.keys(seenProv).forEach(function (p) {
      if (provinces.indexOf(p) === -1) provinces.push(p);
    });
    data.provinces = provinces;

    var cityKeys = {};
    stores.forEach(function (s) { cityKeys[lpSlugKey(s.city) + '|' + s.prov] = 1; });
    data.cities = Object.keys(cityKeys).length;

    return data;
  }

  /* Point d'entree unique : tout ce qui consomme lp-stores.json
     passe par ici. Sans blocs saisis, c'est un simple passe-plat. */
  function lpStoresData(raw) {
    if (!raw) return raw;
    var edits = lpReadStoreEdits();
    if (!edits || !edits.length) return raw;
    try {
      return lpApplyStoreEdits(JSON.parse(JSON.stringify(raw)), edits);
    } catch (e) {
      return raw;                        // on ne casse jamais la carte
    }
  }


  /* ----------------------------------------------------------
     28. LOCALISATEUR — SOURCE METAOBJETS
     Les detaillants vivent dans Contenu > Metaobjets, edites par
     l'equipe. Le gabarit templates/page.pdv-json.liquid les sert
     en JSON ; ici on assemble les pages et on remet les donnees
     dans la forme que la carte attend deja.

     Liquid plafonne a 250 entrees par rendu : la premiere reponse
     annonce le nombre de pages, on va chercher le reste en
     parallele. Les compteurs et la liste des provinces sont
     recalcules ici — plus personne ne les fige dans un fichier.

     Les coordonnees arrivent en un seul champ, telles que
     l'employe les a collees, et passent par lpParseCoords (27) :
     decimales, URL Google, degres, inversion lat/lng.
     ---------------------------------------------------------- */

  /* Apostrophes typographiques ramenees a l'ASCII, comme le fait
     norm_apostrophes() cote Python, puis minuscules. */
  function lpLower(value) {
    return (value == null ? '' : String(value))
      .replace(/[\u2019\u02bc`]/g, "'")
      .toLowerCase();
  }

  function lpFetchStores(url) {
    function page(n) {
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      /* Shopify sert ce gabarit en text/html : on lit le texte et
         on parse nous-memes plutot que de compter sur r.json(). */
      return fetch(url + sep + 'page=' + n, { headers: { Accept: '*/*' } })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (texte) { return JSON.parse(texte); });
    }

    return page(1).then(function (premiere) {
      var rows = (premiere.stores || []).slice();
      var pages = parseInt(premiere.pages, 10) || 1;
      if (pages <= 1) return rows;

      var suite = [];
      for (var n = 2; n <= pages; n++) suite.push(page(n));

      return Promise.all(suite).then(function (restes) {
        restes.forEach(function (p) { rows = rows.concat(p.stores || []); });
        return rows;
      });
    });
  }

  /* Adresse du flux, publiee par theme.liquid depuis les parametres
     du theme. Absente : on reste sur assets/lp-stores.json. */
  function lpFeedUrl() {
    var url = window.LP_STORES_FEED;
    return (typeof url === 'string' && url) ? url : null;
  }

  /* Point d'entree unique des quatre consommateurs (compteurs, carte,
     liste de l'accueil, « pres de chez vous »). Remplit le cache partage
     et rend la main avec les donnees, d'ou qu'elles viennent. */
  function lpLoadStores(assetUrl) {
    if (LP_STORES_CACHE) return Promise.resolve(LP_STORES_CACHE);

    var feed = lpFeedUrl();
    if (feed) {
      return lpFetchStores(feed).then(function (rows) {
        LP_STORES_CACHE = lpBuildStoresPayload(rows);
        return LP_STORES_CACHE;
      });
    }

    return fetch(assetUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        LP_STORES_CACHE = data;
        return data;
      });
  }

  function lpBuildStoresPayload(rows) {
    var stores = [];
    var vus = {};

    (rows || []).forEach(function (row) {
      var name = (row.name || '').trim();
      var city = (row.city || '').trim();
      if (!name || !city) return;            // fiche incomplete : ignoree

      var id = (row.id || '').trim() || lpSlugKey(name + '-' + city);
      if (vus[id]) return;                   // handle en double : le premier gagne
      vus[id] = 1;

      var store = {
        id: id,
        name: name,
        address: (row.address || '').trim(),
        city: city,
        prov: (row.prov || '').trim().toUpperCase(),
        postal: (row.postal || '').trim().toUpperCase()
      };

      if (row.chain) store.chain = String(row.chain).trim();
      if (row.phone) store.phone = String(row.phone).trim();
      if (row.website) store.website = String(row.website).trim();

      var c = lpParseCoords(row.coords);
      if (c) {
        store.lat = c[0];
        store.lng = c[1];
      } else {
        store.nogeo = true;                  // dans la liste, pas sur la carte
      }

      stores.push(store);
    });

    /* Meme tri que scripts/build-stores.py, pour que l'ordre de la
       liste ne change pas en passant d'une source a l'autre. */
    stores.sort(function (a, b) {
      var pa = LP_PROV_ORDER.indexOf(a.prov);
      var pb = LP_PROV_ORDER.indexOf(b.prov);
      if (pa === -1) pa = 99;
      if (pb === -1) pb = 99;
      if (pa !== pb) return pa - pb;
      /* Minuscules sur la chaine brute, pas le slug : c'est la cle
         de tri de build-stores.py. Le slug ecraserait l'apostrophe
         et ferait permuter « Herc's Nutrition » et « Hercs ». */
      var ca = lpLower(a.city);
      var cb = lpLower(b.city);
      if (ca !== cb) return ca < cb ? -1 : 1;
      var na = lpLower(a.name);
      var nb = lpLower(b.name);
      return na === nb ? 0 : (na < nb ? -1 : 1);
    });

    var seenProv = {};
    stores.forEach(function (s) { if (s.prov) seenProv[s.prov] = 1; });
    var provinces = LP_PROV_ORDER.filter(function (p) { return seenProv[p]; });
    Object.keys(seenProv).forEach(function (p) {
      if (provinces.indexOf(p) === -1) provinces.push(p);
    });

    var cityKeys = {};
    stores.forEach(function (s) { cityKeys[lpSlugKey(s.city) + '|' + s.prov] = 1; });

    return {
      generated: '',
      count: stores.length,
      provinces: provinces,
      cities: Object.keys(cityKeys).length,
      chains: [],
      stores: stores
    };
  }

  function run() {
    scanTilt();
    scanRails();
    measureHeader();
    bindHero();
    bindHeroSlider();
    scanTdeck();
    scanDescriptions();
    bindProductPage();
    bindCollection();
    bindFlavourBar();
    bindCompare();
    bindPeek();
    bindCartBar();
    bindBuilder();
    bindStoreStats();
    bindStoreMap();
    bindStack();
    bindContactForm();
    bindParallax();
    bindAnnounceRotate();
    bindCountdown();
    bindCopy();
    bindDealAdd();
    bindStoreList();
    bindTrainingDays();
    bindQuiz();
    bindNearby();
    bindReorder();
  }

  window.addEventListener('resize', function () {
    clearTimeout(window._lpResize);
    window._lpResize = setTimeout(measureHeader, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var observer = new MutationObserver(function (mutations) {
    var touched = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        touched = true;
        break;
      }
    }
    if (touched) {
      clearTimeout(observer._t);
      observer._t = setTimeout(run, 120);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
